const locale = {
  'Invite generated': 'Convite gerado',
  'This token will be shown only once': 'Este token será exibido apenas uma vez',
  'Copy it now and send it through a secure channel. It is single-use and we store only its hash — if lost, revoke it and generate another.': 'Copie agora e envie por um canal seguro. É de uso único e guardamos só o hash — se for perdido, revogue e gere outro.',
  'Copy token': 'Copiar token',
  'Copied': 'Copiado',
  'Expires in': 'Expira em',
  'Expired': 'Expirado',
  'This token expired. Generate another invite to connect this partner.': 'Este token expirou. Gere outro convite para conectar este parceiro.',
  'Contract': 'Contrato',
  'Bidirectional — both apps display': 'Bidirecional — os dois apps exibem',
  'One-way — only their app displays': 'Unilateral — só o app dele exibe',
  'Use': 'Uso',
  'Single use · stored only as a hash': 'Uso único · guardado só como hash',
  'inherits new ones': 'herda novas',
  'Download QR art': 'Baixar Arte do QR',
  'Token copied.': 'Token copiado.',
  'Did you copy the token? It cannot be recovered.': 'Você copiou o token? Ele não poderá ser recuperado.',
  'Close': 'Fechar',
  'I copied it, close': 'Copiei, fechar',
  'Invited tenant': 'Tenant convidado',
  'Select a tenant': 'Selecione um tenant',
  'Contact e-mail': 'E-mail de contato',
  'Accounts in the contract': 'Contas que entram no contrato',
  'sharing always covers every station of the account': 'o compartilhamento é sempre de todas as estações da conta',
  'All accounts': 'Todas as contas',
  'All except...': 'Todas, exceto…',
  'Select accounts': 'Selecionar contas',
  'All accounts included — nothing to filter': 'Todas as contas incluídas — nada a filtrar',
  'Search sub-account by name': 'Buscar subconta por nome',
  'No sub-account with that name': 'Nenhuma subconta com esse nome',
  'select all': 'marcar todas',
  'clear exclusions': 'limpar exceções',
  'Parent account always included': 'Matriz sempre incluída',
  'sub-accounts included automatically': 'subcontas incluídas automaticamente',
  'out of the contract': 'fora do contrato',
  'sub-accounts marked': 'subcontas marcadas',
  'accounts': 'contas',
  'Automatically include new sub-accounts': 'Incluir automaticamente novas subcontas',
  'Visibility contract type': 'Tipo de contrato de visualização',
  'This tenant has an app configured — it can receive stations, so the bidirectional contract is available.': 'Este tenant tem app configurado — pode receber estações, então o contrato bidirecional está disponível.',
  'This tenant has no app configured: it does not receive stations. Only the one-way contract is possible.': 'Este tenant não tem app configurado: ele não recebe estações. Só o contrato unilateral é possível.',
  'Token validity': 'Validade do token',
  '* Required fields. The partner only sees your network after entering the token.': '* Campos de preenchimento obrigatório. O parceiro só passa a enxergar sua rede depois de inserir o token.',
  'Generate invite': 'Gerar convite',
  'Could not generate the invite. Try again.': 'Não foi possível gerar o convite. Tente novamente.',
  'Accounts of my hierarchy in this contract': 'Contas da minha hierarquia neste contrato',
  'Pending changes: {0} entering, {1} leaving': 'Alterações pendentes: {0} entrando, {1} saindo',
  'Apply the new contract scope?': 'Aplicar o novo escopo do contrato?',
  'These accounts, and any sub-accounts below them, stop being displayed to the partner right away: {0}. The contract stays active.': 'Estas contas, e as subcontas abaixo delas, deixam de ser exibidas ao parceiro imediatamente: {0}. O contrato continua ativo.',
  'The marked accounts start being displayed to the partner. The contract stays active.': 'As contas marcadas passam a ser exibidas ao parceiro. O contrato continua ativo.',
  'Apply': 'Aplicar',
  'Apply scope': 'Aplicar escopo',
  'Applying...': 'Aplicando...',
  'Undo': 'Desfazer',
  'will be added': 'entra',
  'will be removed': 'sai',
  'The parent account cannot leave the contract.': 'A matriz não pode sair do contrato.',
  'Contract scope updated.': 'Escopo do contrato atualizado.',
  'Could not change the scope now. Nothing was changed.': 'Não foi possível alterar o escopo agora. Nada foi alterado.',
  'parent account': 'matriz',
  'sub-account': 'subconta',
  'stations': 'estações',
  'Loading...': 'Carregando...',
  'Could not load the accounts of this contract.': 'Não foi possível carregar as contas deste contrato.',
  'New sub-accounts join this contract automatically — no new invite.': 'Novas subcontas entram automaticamente neste contrato — sem novo convite.',
  'New sub-accounts do NOT join automatically: each inclusion is an explicit action.': 'Novas subcontas NÃO entram automaticamente: cada inclusão exige ação explícita.',
  'app configured': 'app configurado',
  'no app': 'sem app',
  'Bidirectional': 'Bidirecional',
  'One-way': 'Unilateral',
  'Ativo': 'Ativo',
  'Convite pendente': 'Convite pendente',
  'Suspenso': 'Suspenso',
  'Revogado': 'Revogado',
  'Suspend': 'Suspender',
  'Reactivate': 'Reativar',
  'Revoke': 'Revogar',
  'You have no connected partners yet': 'Você ainda não tem parceiros conectados',
  'I have an invite token': 'Tenho um token de convite',
  'Show or hide these stations in my app': 'Exibir ou esconder estas estações no meu app',
  'Revoking ends this contract. Reconnecting requires a new invite. Continue?': 'Revogar encerra este contrato. Reconectar exige um novo convite. Continuar?',
  'A contract is only bidirectional when both tenants have an app configured — without an app the partner can share stations but receives none. Turning receiving on or off does not change the contract: it only hides the partner stations in your app.': 'O contrato só é bidirecional quando os dois tenants têm app configurado — sem app, o parceiro pode compartilhar estações, mas não recebe nenhuma. Ligar/desligar o recebimento não altera o contrato: apenas esconde as estações do parceiro no seu app.',
  'Interoperability': 'Interoperabilidade',
  'Connections': 'Conexões',
  'Connection map': 'Mapa de ligações',
  'History': 'Histórico',
  'Invite partner': 'Convidar parceiro',
  'Enter token': 'Inserir token',
  'Review invite': 'Revisar convite',
  'Each accepted invite creates a station visibility contract — bidirectional or one-way.': 'Cada convite aceito cria um contrato de visualização de estações — bidirecional ou unilateral.',
  'wants your app to display their stations': 'quer que você exiba as estações dela no seu app',
  'invite(s) sent awaiting acceptance': 'convite(s) enviado(s) aguardando aceite',
  'Could not load interoperability data. Try again.': 'Não foi possível carregar os dados de interoperabilidade. Tente novamente.',
  'Accept invite': 'Aceitar convite',
  'Paste the token your partner sent you': 'Cole o token que o parceiro enviou',
  'Paste the token sent by': 'Cole o token enviado por',
  'Validate': 'Validar',
  'Single-use and time-limited. The token never appears in the URL — up to 5 attempts.': 'Uso único, com prazo. O token nunca aparece na URL — máximo de 5 tentativas.',
  'Valid token': 'Token válido',
  'Bidirectional contract': 'Contrato bidirecional',
  'One-way contract': 'Contrato unilateral',
  'both sides display each other stations': 'os dois lados exibem as estações um do outro',
  'only your app starts displaying stations': 'apenas o seu app passa a exibir estações',
  'Your app starts displaying': 'Seu app passa a exibir',
  'from': 'da',
  'account(s)': 'conta(s)',
  'starts displaying': 'passa a exibir',
  'of your stations': 'estações suas',
  'I authorize the sharing described above': 'Autorizo o compartilhamento descrito acima',
  'Connect': 'Conectar',
  'Connected with': 'Conectado com',
  'The token was invalidated and cannot be used again. The contract is now active and the stations are already in your combined network.': 'O token foi invalidado e não pode ser usado outra vez. O contrato está ativo e as estações já entraram na sua rede combinada.',
  'expires in': 'expira em',
  'no longer valid': 'não vale mais',
  'expired': 'expirado',
  'This token expired on': 'Este token expirou em',
  'Ask your partner for a new one.': 'Peça outro ao parceiro.',
  'This token has expired.': 'Este token expirou.',
  'This token was already used on': 'Este token já foi utilizado em',
  'This token was already used.': 'Este token já foi utilizado.',
  'This invite was cancelled by whoever sent it.': 'Este convite foi cancelado por quem o enviou.',
  'Too many attempts. Wait a few minutes before trying again.': 'Muitas tentativas. Aguarde alguns minutos antes de tentar de novo.',
  'This is an account token, not an invite token.': 'Esse é o token de uma conta, e não de um convite.',
  'The invite token is the one your partner generates for you.': 'O token do convite é o que o parceiro gera para você.',
  'This is an invite token, not an account token.': 'Esse é o token de um convite, e não de uma conta.',
  'Ask your partner for the token of their account.': 'Peça ao parceiro o token da conta dele.',
  'Account token generated': 'Token da conta gerado',
  'Account token renewed': 'Token da conta renovado',
  'Invites': 'Convites',
  'Direction': 'Direção',
  'Sent': 'Enviado',
  'Received': 'Recebido',
  'Deadline': 'Prazo',
  'Pending': 'Pendente',
  'Accepted': 'Aceito',
  'accepted': 'aceito',
  'accepted on': 'aceito em',
  'expired on': 'venceu em',
  'Revoked': 'Revogado',
  'revoked': 'revogado',
  'Revoke this invite?': 'Revogar este convite?',
  'The token stops working immediately and': 'O token deixa de valer imediatamente e',
  'will no longer be able to accept it. To connect later you have to send a new invite.': 'não poderá mais aceitá-lo. Para conectar depois é preciso enviar um novo convite.',
  'the partner': 'o parceiro',
  'Invite revoked.': 'Convite revogado.',
  'Could not revoke the invite. Nothing was changed.': 'Não foi possível revogar o convite. Nada foi alterado.',
  'Could not load the invites.': 'Não foi possível carregar os convites.',
  'No invites yet. Invite a partner to get started.': 'Nenhum convite ainda. Convide um parceiro para começar.',
  'Only whoever sent an invite can revoke it.': 'Só quem enviou o convite pode revogá-lo.',
  'invites': 'convites',
  'Integrations': 'Integrações',
  'Integrator': 'Integrador',
  'Scopes': 'Escopos',
  'Last use': 'Último uso',
  'never used': 'nunca usado',
  'Active': 'Ativo',
  'Validity': 'Validade',
  'New token': 'Novo token',
  'New integration token': 'Novo token de integração',
  'Create token': 'Criar token',
  'Creating...': 'Criando...',
  'Integration token created': 'Token de integração criado',
  'Read data': 'Consultar dados',
  'Operate charging': 'Operar recarga',
  'Manage contracts': 'Gerenciar contratos',
  'sensitive': 'sensível',
  'Query connections, cross charges, history and contract stations.': 'Consultar conexões, recargas cross, histórico e estações do contrato.',
  'Start and stop charging on the stations this contract reaches. This is the only scope with a physical effect.': 'Iniciar e parar recarga nas estações que este contrato alcança. É o único escopo com efeito físico.',
  'Generate invites, accept, revoke and change scope. A compromised integrator can open your network to a third party.': 'Gerar convites, aceitar, revogar e alterar escopo. Um integrador comprometido pode abrir sua rede para um terceiro.',
  'Who is this integrator?': 'Quem é este integrador?',
  'Billing ACME, BI dashboard, partner app...': 'Faturamento ACME, painel de BI, app do parceiro...',
  'This name is how you will recognize the token later, to revoke it.': 'Este nome é como você vai reconhecer o token depois, para revogá-lo.',
  'What can this token do?': 'O que este token pode fazer?',
  'Nothing is granted by default: mark only what the integrator needs.': 'Nada é liberado por padrão: marque só o que o integrador precisa.',
  'Leave empty for a token that does not expire.': 'Deixe vazio para um token que não expira.',
  'The token is shown once, right after creation.': 'O token é exibido uma vez, logo após a criação.',
  'This token will be shown only once.': 'Este token será exibido apenas uma vez.',
  'Send it to the integrator through a secure channel. We store only a hash — if it is lost, revoke it and create another.': 'Envie ao integrador por um canal seguro. Guardamos apenas o hash — se for perdido, revogue e crie outro.',
  'Revoke this token?': 'Revogar este token?',
  'The integration of': 'A integração de',
  'stops working immediately. To restore it you have to create another token and configure it on their side.': 'para de funcionar imediatamente. Para voltar, é preciso criar outro token e configurá-lo do lado dele.',
  'Token revoked.': 'Token revogado.',
  'Delete': 'Excluir',
  'Delete this revoked token?': 'Excluir este token revogado?',
  'Token deleted.': 'Token excluído.',
  'Could not delete the token. Nothing was changed.': 'Não foi possível excluir o token. Nada foi alterado.',
  'The token': 'O token',
  'is removed for good. This cannot be undone; the audit trail keeps the record.': 'é removido de vez. Isso não pode ser desfeito; a trilha de auditoria mantém o registro.',
  'Delete removes this revoked token for good — the audit trail keeps the record.': 'Excluir remove este token revogado de vez — a trilha de auditoria mantém o registro.',
  'Delete this revoked connection?': 'Excluir esta conexão revogada?',
  'Deleting removes the contract for good. This cannot be undone; the audit trail keeps the record.': 'Excluir remove o contrato de vez. Isso não pode ser desfeito; a trilha de auditoria mantém o registro.',
  'Connection deleted.': 'Conexão excluída.',
  '180 days': '180 dias',
  '1 year': '1 ano',
  'Enable all': 'Habilitar todos',
  'Discard': 'Descartar',
  'Enable': 'Habilitar',
  'Enable eligibility for these accounts?': 'Habilitar elegibilidade para estas contas?',
  'Enabling an account shares its stations and charges with the cross network. Turn on only what should be visible to partners.': 'Habilitar uma conta compartilha as estações e recargas dela com a rede cross. Ligue só o que deve ser visível aos parceiros.',
  'No accounts to show.': 'Nenhuma conta para exibir.',
  'Not shared': 'Não compartilhado',
  'This shares their data with the cross network:': 'Isto compartilha os dados delas com a rede cross:',
  'to disable': 'a desabilitar',
  'to enable': 'a habilitar',
  'will be turned off.': 'serão desligadas.',
  'Eligibility enabled': 'Elegibilidade habilitada',
  'Eligibility disabled': 'Elegibilidade removida',
  'Children': 'Filhos',
  'Clear all': 'Limpar todos',
  'Search account by name': 'Buscar conta pelo nome',
  'No account matches this search.': 'Nenhuma conta corresponde a esta busca.',
  'Applies to every account on this level, including the other pages.': 'Vale para todas as contas deste nível, inclusive as das outras páginas.',
  'not shown (other company)': 'não exibido (outra empresa)',
  'not recorded': 'não registrado',
  'Could not load the accounts.': 'Não foi possível carregar as contas.',
  'Could not update eligibility. Nothing was changed.': 'Não foi possível atualizar a elegibilidade. Nada foi alterado.',
  'Eligibility': 'Elegibilidade',
  'Eligibility updated.': 'Elegibilidade atualizada.',
  'Enable which accounts can take part in interoperability. Enabling replicates that account stations and charges to the cross network — turn on only what should be shared.': 'Habilite quais contas participam da interoperabilidade. Habilitar replica as estações e recargas daquela conta para a rede cross — ligue só o que deve ser compartilhado.',
  'Grandchildren': 'Netos',
  'Interoperability eligibility': 'Elegibilidade de interoperabilidade',
  'Level': 'Nível',
  'No changes to save.': 'Nenhuma alteração para salvar.',
  'No pending changes.': 'Nenhuma alteração pendente.',
  'Save changes': 'Salvar alterações',
  'Saving…': 'Salvando…',
  'This account': 'Esta conta',
  'pending changes': 'alterações pendentes',
  'Delete removes this revoked invite for good — the audit trail keeps the record.': 'Excluir remove este convite revogado de vez — a trilha de auditoria mantém o registro.',
  'Delete this revoked invite?': 'Excluir este convite revogado?',
  'The invite is removed for good. This cannot be undone; the audit trail keeps the record.': 'O convite é removido de vez. Isso não pode ser desfeito; a trilha de auditoria mantém o registro.',
  'Invite deleted.': 'Convite excluído.',
  'Could not delete the invite. Nothing was changed.': 'Não foi possível excluir o convite. Nada foi alterado.',
  '(defaults to the current tenant)': '(padrão: o tenant atual)',
  '(empty response)': '(resposta vazia)',
  'API documentation sections': 'Seções da documentação da API',
  'Body': 'Corpo',
  'Documentation': 'Documentação',
  'Filter by method, path or description': 'Filtrar por método, caminho ou descrição',
  'Filter endpoints': 'Filtrar endpoints',
  'Guide': 'Guia',
  'Hide Try it': 'Ocultar Testar',
  'How your integrators authenticate and what the API offers. The Postman collection carries the same endpoints.': 'Como seus integradores se autenticam e o que a API oferece. A coleção do Postman traz os mesmos endpoints.',
  'In': 'Em',
  'Integration token (Bearer) — not stored': 'Token de integração (Bearer) — não armazenado',
  'Internal API': 'API interna',
  'Internal tenant-cross endpoints, generated from the backend. They authenticate by tenant identity or session, not by the integration token.': 'Endpoints internos do tenant-cross, gerados a partir do backend. Autenticam por identidade de tenant ou sessão, não pelo token de integração.',
  'No endpoint matches this search.': 'Nenhum endpoint corresponde a esta busca.',
  'Parameters': 'Parâmetros',
  'Partner API': 'API de parceiro',
  'Request body': 'Corpo da requisição',
  'Send': 'Enviar',
  'Sending…': 'Enviando…',
  'The integration endpoints, authenticated by the integration token.': 'Os endpoints de integração, autenticados pelo token de integração.',
  'Tokens': 'Tokens',
  'Try it': 'Testar',
  'current tenant': 'tenant atual',
  'endpoints': 'endpoints',
  'path': 'rota',
  'query': 'query',
  'Could not revoke the token. Nothing was changed.': 'Não foi possível revogar o token. Nada foi alterado.',
  'Could not create the token.': 'Não foi possível criar o token.',
  'Could not create the token now. Try again in a moment.': 'Não foi possível criar o token agora. Tente de novo em instantes.',
  'Could not load the integration tokens.': 'Não foi possível carregar os tokens de integração.',
  'No integration tokens yet. Create one to give an integrator access.': 'Nenhum token de integração ainda. Crie um para dar acesso a um integrador.',
  'Tokens your integrators use to operate in your name. Each one carries only the scopes you grant, is shown once at creation, and can be revoked at any time.': 'Tokens que seus integradores usam para operar em seu nome. Cada um carrega só os escopos que você libera, é exibido uma vez na criação e pode ser revogado a qualquer momento.',
  'A token is never shown again after creation — if one is lost, revoke it and create another.': 'Um token nunca é exibido de novo depois da criação — se algum for perdido, revogue e crie outro.',
  'Token': 'Token',
  'not identified': 'não identificado',
  'Renew this token?': 'Renovar este token?',
  'The current secret stops working immediately and': 'O segredo atual para de funcionar imediatamente e',
  'will need the new one. Name and scopes stay the same.': 'vai precisar do novo. Nome e escopos continuam os mesmos.',
  'Token renewed.': 'Token renovado.',
  'Could not renew the token. Nothing was changed.': 'Não foi possível renovar o token. Nada foi alterado.',
  'Extend validity': 'Estender validade',
  'Extend this token?': 'Estender este token?',
  'The same secret goes back to working, with no expiry date.': 'O mesmo segredo volta a valer, sem data de vencimento.',
  'It was never compromised — it only aged out.': 'Ele nunca foi comprometido — apenas venceu.',
  'Validity extended.': 'Validade estendida.',
  'Could not extend the validity. Nothing was changed.': 'Não foi possível estender a validade. Nada foi alterado.',
  'Recreate': 'Recriar',
  'Create a new token like this one?': 'Criar um token novo como este?',
  'A new token is created with the same name and scopes.': 'Um token novo é criado com o mesmo nome e escopos.',
  'The revoked one stays revoked in the list — the old secret never comes back.': 'O revogado continua revogado na lista — o segredo antigo não volta.',
  'Token recreated.': 'Token recriado.',
  'Could not recreate the token. Nothing was changed.': 'Não foi possível recriar o token. Nada foi alterado.',
  'Representative e-mail': 'E-mail do representante',
  'optional': 'opcional',
  'Who to contact when the integration breaks. Recorded in the module history.': 'Quem procurar quando a integração quebrar. Fica registrado no histórico do módulo.',
  'The token is never sent by e-mail.': 'O token nunca é enviado por e-mail.',
  'Search integrator, e-mail or token': 'Buscar integrador, e-mail ou token',
  'All states': 'Todos os estados',
  'Any scope': 'Qualquer escopo',
  'tokens': 'tokens',
  'of': 'de',
  'No token matches these filters.': 'Nenhum token corresponde a estes filtros.',
  'Actions': 'Ações',
  'Granted': 'Concedidos',
  'Created by': 'Criado por',
  'Last renewal': 'Última renovação',
  'Revoked on': 'Revogado em',
  'The full value is never shown again — only these last characters identify it.': 'O valor completo não é exibido de novo — só estes últimos caracteres identificam.',
  'Creates a new token with the same name and scopes. This one stays revoked, and its secret never comes back.': 'Cria um token novo com o mesmo nome e escopos. Este continua revogado, e o segredo dele não volta.',
  'Expired, not compromised: extending brings the same secret back, so the integrator does not have to change anything.': 'Vencido, não comprometido: estender traz o mesmo segredo de volta, então o integrador não precisa mudar nada.',
  'Renewing swaps the secret and keeps name and scopes — the integrator has to be given the new value. Revoking ends this access for good.': 'Renovar troca o segredo e mantém nome e escopos — o integrador precisa receber o novo valor. Revogar encerra este acesso de vez.',
  'API': 'API',
  'Download Postman collection': 'Baixar coleção do Postman',
  'How to integrate': 'Como integrar',
  'This API exposes what this account shares through interoperability contracts. An integrator authenticates with a token you create here, and sees only what the token scopes allow.': 'Esta API expõe o que esta conta compartilha pelos contratos de interoperabilidade. O integrador se autentica com um token criado aqui, e vê só o que os escopos permitem.',
  'Create a token with the scopes the integrator needs': 'Crie um token com os escopos que o integrador precisa',
  'Use "New token" above. Nothing is granted by default — mark only what they need. The value appears once, right after creation, and is never shown again.': 'Use "Novo token" acima. Nada é liberado por padrão — marque só o que ele precisa. O valor aparece uma vez, logo após a criação, e nunca mais.',
  'Send the token on every request': 'Envie o token em toda requisição',
  'The token goes in the': 'O token vai no cabeçalho',
  'header, never in the URL — a URL ends up in browser history and proxy logs.': ', nunca na URL — URL entra em histórico de navegador e log de proxy.',
  'The base address of this environment is': 'O endereço base deste ambiente é',
  'Note there is no tenant in the path: the token itself says which account it is.': 'Note que não há tenant no caminho: o próprio token diz de que conta se trata.',
  'Handle the refusals': 'Trate as recusas',
  'means the token is missing, revoked or expired.': 'significa token ausente, revogado ou vencido.',
  'means the token is valid but lacks a scope this endpoint requires — ask for a token with that scope instead of retrying.': 'significa token válido sem um escopo que o endpoint exige — peça um token com aquele escopo em vez de tentar de novo.',
  'means something in the request is wrong.': 'significa algo errado na requisição.',
  'Rotate when needed': 'Rotacione quando precisar',
  'A lost token cannot be recovered — open its details and use Renew, which keeps the name and scopes and swaps the secret. Revoking ends the access for good.': 'Token perdido não se recupera — abra o detalhe e use Renovar, que mantém nome e escopos e troca o segredo. Revogar encerra o acesso de vez.',
  'What each scope unlocks. They are independent: one does not imply another.': 'O que cada escopo libera. São independentes: um não implica o outro.',
  'Endpoints': 'Endpoints',
  'Everything the integration API offers today.': 'Tudo o que a API de integração oferece hoje.',
  'The same list is in the Postman collection you can download above.': 'A mesma lista está na coleção do Postman que você baixa acima.',
  'Parameter': 'Parâmetro',
  'Description': 'Descrição',
  'Example': 'Exemplo',
  'Response': 'Resposta',
  'Search partner by name or alias': 'Buscar parceiro por nome ou alias',
  'All statuses': 'Todos os status',
  'Pending invite': 'Convite pendente',
  'Suspended': 'Suspenso',
  'Any contract': 'Qualquer contrato',
  'Only the ones I receive from': 'Só os que eu recebo',
  'connections': 'conexões',
  'No connection matches these filters.': 'Nenhuma conexão corresponde a estes filtros.',
  'Both directions': 'Os dois sentidos',
  'No invite matches these filters.': 'Nenhum convite corresponde a estes filtros.',
  'Both apps display the other stations': 'Os dois apps exibem as estações do outro',
  'Only your app displays the partner stations': 'Só o seu app exibe as estações do parceiro',
  'Only the partner app displays your stations': 'Só o app do parceiro exibe as suas estações',
  'Any problem': 'Qualquer problema',
  'Available stations': 'Estações disponíveis',
  'Connectors': 'Conectores',
  'Coordinates': 'Coordenadas',
  'Correct': 'Correto',
  'Could not load the stations.': 'Não foi possível carregar as estações.',
  'Details': 'Detalhes',
  'Disabled': 'Desabilitada',
  'Enabled': 'Habilitada',
  'Identifier': 'Identificador',
  'It does not show up in the catalogue the partner reads.': 'Ela não sai no catálogo que o parceiro consulta.',
  'It has never reported since it was registered — different from being offline now.': 'Nunca deu sinal desde o cadastro — diferente de estar offline agora.',
  'Last signal': 'Último sinal',
  'Location': 'Local',
  'Name': 'Nome',
  'Never connected': 'Nunca conectou',
  'No': 'Não',
  'No address': 'Sem endereço',
  'No connector': 'Sem conector',
  'No coordinates': 'Sem coordenada',
  'No station matches this filter.': 'Nenhuma estação corresponde a este filtro.',
  'No tariff': 'Sem tarifa',
  'Nothing: this station is correctly registered.': 'Nada: esta estação está cadastrada corretamente.',
  'Number': 'Número',
  'Offline': 'Offline',
  'Online': 'Online',
  'Owner account': 'Conta dona',
  'Partners': 'Parceiros',
  'Registration': 'Cadastro',
  'Registration data': 'Dados de cadastro',
  'Search by name or number': 'Buscar por nome ou número',
  'Stations': 'Estações',
  'Status now': 'Estado agora',
  'The partner app searches by radius, so the station never appears in the results.': 'O app do parceiro busca por raio, então a estação nunca aparece no resultado.',
  'The partner displays the station without saying where it is.': 'O parceiro exibe a estação sem dizer onde ela fica.',
  'The partner does not know the price it will charge its own user.': 'O parceiro não sabe o preço que vai cobrar do usuário dele.',
  'There is nothing to start: the partner user cannot charge here.': 'Não há o que iniciar: o usuário do parceiro não consegue recarregar aqui.',
  'What is wrong': 'O que está errado',
  'Yes': 'Sim',
  'connectors': 'conectores',
  'never': 'nunca',
  'no address': 'sem endereço',
  'none': 'nenhum',
  'Cancel': 'Cancelar',
  'Created': 'Criado',
  'Duration': 'Duração',
  'Energy': 'Energia',
  'Event': 'Evento',
  'Payment': 'Pagamento',
  'Station': 'Estação',
  'Transactions': 'Transações',
  'Type': 'Tipo',
  'Every station reached by an active contract, in both directions, with the contract it belongs to and what would reach the partner broken.': 'Toda estação alcançada por um contrato ativo, nos dois sentidos, com o contrato a que ela pertence e o que chegaria quebrado no parceiro.',
  'Accepted at': 'Aceito em',
  'Accepted by': 'Aceito por',
  'Accounts in scope': 'Contas no escopo',
  'Author': 'Autor',
  'Detail': 'Detalhe',
  'Ended at': 'Terminou em',
  'Expires at': 'Expira em',
  'Generated by': 'Gerado por',
  'IP': 'IP',
  'Includes new sub-accounts': 'Inclui novas subcontas',
  'Invite': 'Convite',
  'Numbers': 'Números',
  'OCPP code': 'Código OCPP',
  'Origin': 'Origem',
  'Started at': 'Começou em',
  'Trail': 'Trilha',
  'User': 'Usuário',
  'The token is shown only once, when the invite is generated: it is stored as a hash and cannot be displayed again. To hand it over once more, generate a new invite.': 'O token é mostrado uma única vez, na geração do convite: ele é gravado como hash e não pode ser exibido de novo. Para entregá-lo outra vez, gere um novo convite.',
  'Could not load the connectors.': 'Não foi possível carregar os conectores.',
  'List': 'Lista',
  'Map': 'Mapa',
  'No station in this filter has coordinates to show on the map.': 'Nenhuma estação deste filtro tem coordenada para mostrar no mapa.',
  'Open details': 'Abrir detalhe',
  'Ready for the partner': 'Pronta para o parceiro',
  'See only those': 'Ver só essas',
  'Showing the first': 'Mostrando as primeiras',
  'The partner cannot use it': 'O parceiro não consegue usar',
  'This station has no connector registered.': 'Esta estação não tem conector cadastrado.',
  'Usable, with wrong data': 'Usável, com dado errado',
  'never reported': 'nunca reportou',
  'no own tariff': 'sem tarifa própria',
  'no power': 'sem potência',
  'no type': 'sem tipo',
  'of the filtered stations have no coordinates and do not appear on the map.': 'das estações do filtro não têm coordenada e não aparecem no mapa.',
  'own tariff': 'tarifa própria',
  'stations in this filter.': 'estações deste filtro.',
  'Available': 'Disponível',
  'Preparing': 'Preparando',
  'Charging': 'Carregando',
  'Suspended by the vehicle': 'Suspenso pelo veículo',
  'Suspended by the station': 'Suspenso pela estação',
  'Finishing': 'Finalizando',
  'Reserved': 'Reservado',
  'Faulted': 'Em falha',
  'Charging group full': 'Energia indisponível',
  'Unavailable': 'Indisponível',
  'Failure': 'Falha',
  'Most stations in': 'Mais estações em',
  'Fewer stations': 'menos estações',
  'More stations': 'mais estações',
  'on the map without an address': 'no mapa sem endereço',
  'The map could not be drawn. The rest of the screen keeps working.': 'Não foi possível desenhar o mapa. O resto da tela continua funcionando.',
  'Density': 'Densidade',
  'The density layer failed:': 'A camada de densidade falhou:',
  'Points': 'Pontos',
  'with problems': 'com problema',
  'No registration problem in this filter.': 'Nenhum problema de cadastro neste filtro.',
  'Nothing missing: the partner can use these.': 'Não falta nada: o parceiro consegue usar.',
  'Clear filter': 'Limpar filtro',
  'filtering by': 'filtrando por',
  'Audit': 'Auditoria',
  'Contracts': 'Contratos',
  'Diagram': 'Diagrama',
  'Only available on an effective contract where you receive stations': 'Só disponível em contrato efetivado no qual você recebe estações',
  'Invalid token. Check whether you copied the whole code.': 'Token inválido. Confira se copiou o código completo.',
  'Could not check the token now. Try again in a moment.': 'Não foi possível conferir o token agora. Tente novamente em instantes.',
  'Could not accept the invite now. Try again in a moment.': 'Não foi possível aceitar o convite agora. Tente novamente em instantes.',
  'wants your app to display': 'quer que você exiba',
  'All partners': 'Todos os parceiros',
  'Could not download the CSV. The list on screen is unchanged.': 'Não foi possível baixar o CSV. A lista na tela não foi afetada.',
  'Download CSV': 'Baixar CSV',
  'Could not load the charges. Try again.': 'Não foi possível carregar as recargas. Tente novamente.',
  'No cross charges in this period.': 'Nenhuma recarga cross neste período.',
  'Charge': 'Recarga',
  'Connector': 'Conector',
  'Origin tenant': 'Tenant de origem',
  'Energy (kWh)': 'Energia (kWh)',
  'Revenue': 'Receita',
  'in progress': 'carregando',
  'Totals for the filtered period': 'Totais do período filtrado',
  'Charges': 'Recargas',
  'To invoice': 'A faturar',
  'Users from other tenants are always masked': 'Usuários de outros tenants sempre mascarados',
  'Page': 'Página',
  'charges': 'recargas',
  'Previous': 'Anterior',
  'Next': 'Próxima',
  'Submit': 'Enviar',
  'Station no longer registered': 'Estação não mais cadastrada',
  'Preparing...': 'Preparando...',
  'Charging...': 'Carregando...',
  'Invite revoked': 'Convite revogado',
  'Invite expired': 'Convite expirado',
  'Token used': 'Token utilizado',
  'Invalid token attempt': 'Tentativa de token inválida',
  'Scope changed': 'Escopo alterado',
  'Subaccount included automatically': 'Subconta incluída automaticamente',
  'Connection suspended': 'Conexão suspensa',
  'Connection reactivated': 'Conexão reativada',
  'Connection revoked': 'Conexão revogada',
  'Success': 'Sucesso',
  'Blocked': 'Bloqueado',
  'All events': 'Todos os eventos',
  'Could not load the history. Try again.': 'Não foi possível carregar o histórico. Tente novamente.',
  'No events in this period.': 'Nenhum evento neste período.',
  'Date / time': 'Data / hora',
  'Responsible': 'Responsável',
  'Partner': 'Parceiro',
  'Result': 'Resultado',
  'no human author': 'sem autor humano',
  'unnamed tenant': 'tenant sem nome',
  'unknown': 'desconhecido',
  'attempt': 'tentativa',
  'Read-only trail: events cannot be edited or deleted.': 'Trilha somente leitura: eventos não podem ser editados nem apagados.',
  'events': 'eventos',
  'My hierarchy → partners': 'Minha hierarquia → parceiros',
  'Flow': 'Fluxo',
  'Mind map': 'Mapa mental',
  'Mind map: your head account at the center, subaccounts on the left, partners around. Solid arrow = I share; dashed arrow back = I receive.': 'Mapa mental: sua matriz no centro, subcontas à esquerda, parceiros à volta. Seta cheia = eu compartilho; seta pontilhada de volta = eu recebo.',
  'Showing only the selected partner links — click it again to see all.': 'Mostrando só as ligações do parceiro selecionado — clique nele de novo para ver todas.',
  'Click a partner on the right to isolate its links.': 'Clique em um parceiro à direita para isolar as ligações dele.',
  'Could not load the map. Try again.': 'Não foi possível carregar o mapa. Tente novamente.',
  'No contracts or open invites to draw yet.': 'Nenhum contrato ou convite aberto para desenhar ainda.',
  'MY ACCOUNTS': 'MINHAS CONTAS',
  'PARTNERS': 'PARCEIROS',
  'head account': 'matriz',
  'subaccount': 'subconta',
  'Active bidirectional contract — both apps display': 'Contrato bidirecional ativo — os dois apps exibem',
  'Active one-way contract — only the partner displays': 'Contrato unilateral ativo — só o parceiro exibe',
  'Pending invite — nothing shared yet': 'Convite pendente — nada compartilhado ainda',
  'Suspended — contract stands, nothing displayed': 'Suspenso — contrato mantido, nada exibido',
  'Last session': 'Última sessão',
  'Partner app': 'App do parceiro',
  'Show these stations in my app': 'Exibir estas estações no meu app',
  'Stations I receive': 'Estações que eu recebo',
  'Stations I share': 'Estações que eu compartilho',
  'Status': 'Status',
  'Without an app the partner can share stations but receives none, so the contract cannot be bidirectional.': 'Sem app o parceiro pode compartilhar estações, mas não recebe nenhuma — então o contrato não pode ser bidirecional.',
  'Partner accounts in this contract': 'Contas do parceiro neste contrato',
  'Your account token': 'Token da sua conta',
  'Hand this token to a partner so they can invite your account. Whoever has it can only invite you — accepting is still your decision.': 'Entregue este token a um parceiro para ele convidar a sua conta. Quem o tem só consegue convidar você — aceitar continua sendo a sua decisão.',
  'Could not load the token. Try again.': 'Não foi possível carregar o token. Tente novamente.',
  'This account has no token yet.': 'Esta conta ainda não tem token.',
  'Copy': 'Copiar',
  'Expired on': 'Venceu em',
  'renew to share again': 'renove para voltar a compartilhar',
  'Valid until': 'Válido até',
  'Does not expire': 'Não vence',
  'renewed on': 'renovado em',
  'does not expire': 'não vence',
  '7 days': '7 dias',
  '30 days': '30 dias',
  '90 days': '90 dias',
  'Renew': 'Renovar',
  'Generate token': 'Gerar token',
  'Renewing invalidates the current token.': 'Renovar invalida o token atual.',
  'Renewing invalidates the current token: partners who have it can no longer invite you. Continue?': 'Renovar invalida o token atual: parceiros que já o têm deixam de conseguir convidar você. Continuar?',
  'Open contract': 'Abrir contrato',
  'Partner account token': 'Token da conta parceira',
  'Check': 'Verificar',
  'Checking...': 'Verificando...',
  'Ask the partner for the token shown on their Interoperability screen.': 'Peça ao parceiro o token que aparece na tela de Interoperabilidade dele.',
  'Could not check this token now. Try again in a moment.': 'Não foi possível verificar este token agora. Tente novamente em instantes.',
  'The current token could not be read. Generating a new one invalidates whatever token exists, and partners holding it will no longer be able to invite you.': 'Não foi possível ler o token atual. Gerar um novo invalida o token que existir, e parceiros que o tenham em mãos deixam de conseguir convidar você.',
  'Renew the account token?': 'Renovar o token da conta?',
  'Partners who already have the current token will no longer be able to invite you. Send them the new one.': 'Parceiros que já têm o token atual deixam de conseguir convidar você. Envie o novo a eles.',
  'Revoke the contract with this partner?': 'Revogar o contrato com este parceiro?',
  'Suspend this contract?': 'Suspender este contrato?',
  'Suspending hides your {0} stations in the app of {1} until you reactivate.': 'Suspender vai ocultar suas {0} estações no app de {1} até você reativar.',
  'Suspending hides the {0} stations of {1} in your app until you reactivate.': 'Suspender vai ocultar as {0} estações de {1} no seu app até você reativar.',
  'Suspending hides your {0} stations in the app of {1}, and the {2} stations of theirs in your app, until you reactivate.': 'Suspender vai ocultar suas {0} estações no app de {1}, e as {2} estações dele no seu app, até você reativar.',
  'Revoking is not reversible: the stations stop being displayed on both sides, and reconnecting requires a new invite.': 'Revogar não é reversível: as estações deixam de ser exibidas nos dois lados, e reconectar exige um novo convite.',
  '— awaiting acceptance': '— aguardando aceite',
  '— contract ended': '— contrato encerrado',
  'does not receive — one-way contract': 'não recebe — contrato unilateral',
  '{0} stations shown in my app': '{0} estações exibidas no meu app',
  '{0} stations received · hidden in the app': '{0} estações recebidas · ocultas no app',
  '{0} in the invite · awaiting acceptance': '{0} no convite · aguardando aceite',
  '0 · contract ended': '0 · contrato encerrado',
  'stations · {0} account': 'estações · {0} conta',
  'stations · {0} accounts': 'estações · {0} contas',
  'Turning receiving on or off does not change the contract: it only hides the partner stations in your app.': 'Ligar ou desligar o recebimento não altera o contrato: apenas esconde as estações do parceiro no seu app.',
  'Could not complete the action. Nothing was changed.': 'Não foi possível concluir a ação. Nada foi alterado.',
  'Contract revoked.': 'Contrato revogado.',
  'Contract suspended.': 'Contrato suspenso.',
  'Contract reactivated.': 'Contrato reativado.',
  'Stations now visible in your app.': 'Estações passam a aparecer no seu app.',
  'Stations hidden in your app.': 'Estações escondidas no seu app.',
  'Could not load interoperability data.': 'Não foi possível carregar os dados de interoperabilidade.',
  'Could not load the charges.': 'Não foi possível carregar as recargas.',
  'Could not load the history.': 'Não foi possível carregar o histórico.',
  'Could not load the map.': 'Não foi possível carregar o mapa.',
  'This tab is delivered in its own task.': 'Esta aba é entregue em tarefa própria.',
  'Firmware Update History': 'Histórico de Atualização de Firmware',
  'Search by station': 'Buscar por estação',
  Charger: 'Carregador',
  'Update date': 'Data de atualização',
  'MCU previous version': 'MCU versão anterior',
  'MCU current version': 'MCU versão atual',
  'Initial version': 'Versão inicial',
  'Gateway previous version': 'Gateway versão anterior',
  'Gateway current version': 'Gateway versão atual',
  'Updated by': 'Atualizado por',
  'Remote update': 'Atualização remota',
  'Updates in period': 'Atualizações no período',
  'Last update': 'Última atualização',
  'Firmware History': 'Histórico de Firmware',
  'Total records': 'Total de registros',
  'Update records': 'Registros de atualização',
  results: 'resultados',
  'No records found': 'Nenhum registro encontrado',
  Showing: 'Mostrando',
  of: 'de',
  Restart: 'Reiniciar',
  'Trusted user audit history': 'Histórico de alterações — Usuário confiável',
  'Date/Time': 'Data/Hora',
  'Previous value': 'Anterior',
  'New value': 'Novo',
  Trusted: 'Confiável',
  'Not trusted': 'Não confiável',
  'Could not load audit history': 'Não foi possível carregar o histórico.',
  'General View': 'Visão Geral',
  'Not Available': 'Não Disponível',
  Home: 'Início',
  'User charged': 'Usuário carregou',
  'Users charged': 'Usuários carregaram',
  'Registered user': 'Usuário cadastrado',
  'Registered users': 'Usuários cadastrados',
  'CONSUMED kWh TOTAL': 'TOTAL DE kWh CONSUMIDOS',
  'Period Total': 'Total no período',
  Period: 'Período',
  Indicators: 'Indicadores',
  Support: 'Suporte',
  'Required fields': 'Campos de preenchimento obrigatório',
  Submit: 'Enviar',
  'Type 1': 'Tipo 1',
  'Type 2': 'Tipo 2',
  'Type 3': 'Tipo 3',
  Available: 'Disponível',
  Unavailable: 'Indisponível',
  Preparing: 'Preparando',
  Charging: 'Carregando',
  'Not Charging': 'Não Carregando',
  Finishing: 'Terminando',
  Reserved: 'Reservado',
  Faulted: 'Com defeito',
  Unspecified: 'Não especificado',
  'ChargeBox ID': 'Código de identificação da Estação',
  'Endpoint address': 'Endereço web',
  'Registration status': 'Status de registro',
  Accepted: 'Aceito',
  Declined: 'Recusado',
  Rejected: 'Rejeitado',
  'Insert connector status after start/stop transaction':
    'Inserir o status do conector após iniciar/parar a transação',
  Street: 'Rua',
  'House number': 'Número',
  'Zip code': 'CEP',
  City: 'Cidade',
  State: 'UF',
  Country: 'País',
  Description: 'Descrição',
  'Admin address': 'Endereço admin',
  'Location Latitude': 'Latitude (Localização)',
  'Location Longitude': 'Longitude (Localização)',
  Type: 'Tipo',
  Public: 'Pública',
  Private: 'Privada',
  'ChargeBox Group': 'Grupo da Estação',
  'Show location': 'Mostrar localização',
  'Open 24 hours': 'Aberto 24 horas',
  'Open time': 'Horário de abertura',
  'Close time': 'Horário de fechamento',
  'Customize per day': 'Personalizar por dia',
  'Set opening and closing hours for each day of the week': 'Configura os horários de abertura e fechamento em cada dia da semana',
  'Automatically stop charging when station closes': 'Encerrar recargas automaticamente ao fechar',
  'Closed': 'Fechado',
  'Period': 'Período',
  'Sunday': 'Domingo',
  'Monday': 'Segunda-feira',
  'Tuesday': 'Terça-feira',
  'Wednesday': 'Quarta-feira',
  'Thursday': 'Quinta-feira',
  'Friday': 'Sexta-feira',
  'Saturday': 'Sábado',
  'At least one day must have operating hours': 'Pelo menos um dia deve ter horário de funcionamento',
  'Start time must be before end time for all periods': 'O horário de início deve ser anterior ao de término em todos os períodos',
  'Minimum reservation': 'Reserva mínima',
  Accessibility: 'Acessibilidade',
  'Free publicly accessible': 'Livre acessível ao público',
  'Restricted access': 'Acesso restrito',
  'Paying publicly accessible': 'Pagável acessível ao público',
  'Test station': 'Estação de teste',
  'Authentication mode': 'Modo de autenticação',
  'Max. time future': 'Max. tempo futuro',
  'Dynamic info available': 'Informação dinâmica disponível',
  True: 'Verdadeiro',
  False: 'Falso',
  'Connector ID': 'ID do Conector',
  'Connector type': 'Tipo do conector',
  'Power Max': 'Potência Máx (kW)',
  'Has Payment': 'Recarga será cobrada',
  'Cost per kWh': 'Custo (R$) por kWh',
  'Cost per kWh (R$)': 'Custo por kWh (R$)',
  'Cost per duration': 'Custo (R$) por tempo(min)',
  'Income per kWh': 'Receita (R$) por kWh',
  'Income per kWh (R$)': 'Receita por kWh (R$)',
  'Income per Duration': 'Receita (R$) por tempo(min)',
  'Income per Transaction': 'Receita (R$) por Início de Recarga',
  'Tax Income': 'Taxa por Receita (%)',
  'Additional Note': 'Nota adicional',
  Name: 'Nome',
  'Last name': 'Sobrenome',
  Birthday: 'Aniversário',
  'User Active': 'Usuário Ativo',
  'Offline Stations Notification': 'Notif. Estações Off-line',
  'Choose Connector ID': 'Escolha o id do conector',
  'Choose OCPP ID Tag': 'Escolha o Identificador da Tag RFID',
  'Choose Transaction ID': 'Escolha o id da transação',
  'Choose Reset Type': 'Escolha o tipo do reset',
  'Conf Key List': 'Lista de chaves de configuração',
  Select: 'Selecione',
  'Select all': 'Selecionar todas',
  'Reset selection': 'Limpar seleção',
  'Change Availability': 'Mudar Disponibilidade',
  'Availability Type': 'Tipo de Disponibilidade',
  'Remote Start Transaction': 'Iniciar Transação Remota',
  'Remote Stop Transaction': 'Parar Transação Remota',
  Reset: 'Reiniciar',
  'Get Configuration': 'Obter Configuração',
  'Change Configuration': 'Trocar Configuração',
  'Key Type': 'Tipo de Chave',
  'Configuration Key': 'Chave de Configuração',
  'Custom Configuration Key': 'Chave de Configuração Personalizada',
  Value: 'Valor',
  'Power Limit': 'Limite de Potência',
  'Trigger Message': 'Mensagem de Gatilho',
  'Set Charging Profile': 'Definir Perfil de Recarga',
  'Clear Charging Profile': 'Limpar Perfil de Recarga',
  'Send Local List': 'Enviar Lista local',
  'Reserve Now': 'Reservar Agora',
  'Expiry Date': 'Data de Expiração',
  'Get Diagnostics': 'Obter Diagnóstico',
  'Unlock Connector': 'Desbloquear Conector',
  'Update Firmware': 'Atualizar Firmware',
  'Directory URI': 'URI do diretório',
  'Retries (integer)': 'Tentativas (número inteiro)',
  'Retry Interval (integer)': 'Intervalo de repetição (número inteiro)',
  'Retrieve DateTime Firmware': 'Data e Hora para recuperar',
  Optional: 'Opcional',
  'Task ID': 'Id da tarefa',
  'OCPP Version': 'Versão OCPP',
  'Operation Name': 'Nome da operação',
  Origin: 'Origem',
  'Start Timestamp': 'Horário de início',
  'End Timestamp': 'Horário de fim',
  'Error Message': 'Mensagem de erro',
  Response: 'Resposta',
  'All connectors': 'Todos conectores',
  Tasks: 'Tarefas',
  'Choose profile': 'Escolha o perfil',
  Goal: 'Meta',
  Remaining: 'Restante',
  Using: 'Usando',
  'Not using': 'Não usando',
  Password: 'Senha',
  Phone: 'Telefone/ Celular',
  'User Group': 'Grupo do usuário',
  'New Charging Profile': 'Novo Perfil de Recarga',
  'Edit Charging Profile': 'Editar Perfil de Recarga',
  Edit: 'Editar',
  'Not allowed': 'Sem permissão',
  'Is Hubject Compatible': 'Compatível com a Hubject',
  'Is OCPI Compatible': 'Compatível com OCPI',
  'Edit User': 'Editar Usuário',
  'Creating User': 'Cadastro de usuário',
  'Editing User': 'Editando Usuário',
  'External ID': 'ID Externo',
  'Ocpp Tags': 'Tags RFID',
  'Payment Charge Type Cost': 'Tipo de cobrança',
  'Payment Charge Type Income': 'Tipo de cobrança para receita',
  'Payment Charge Type KWH': 'Por kWh',
  'Payment Charge Type Duration': 'Por tempo(min)',
  'Price Profile Activated (Editing is not allowed while the station has an activated Price Profile)':
    'Perfil de Preço Ativado (Não é possível edição quando possui um Perfil de Preço Ativado para Estação)',
  'Payment Charge By Income': 'Cobrança de receita por',
  'Payment Charge By Income Station': 'Estação',
  'Payment Charge By Income Connector': 'Conector',
  Others: 'Outros',
  'Enable Face Reader': 'Habilitar Leitor Facial',
  'Enable Station': 'Habilitar Estação',
  'Facial Reader - MAC Address': 'Leitor Facial - Endereço MAC',
  'Reservation enabled': 'Habilitar reserva',
  'Data Transfer': 'Transferência de Dados',
  'Vendor ID': 'ID do fabricante',
  'Message ID': 'ID da mensagem',
  Data: 'Dados',
  'Confirm payment?': 'Confirma o pagamento?',
  Yes: 'Sim',
  Cancel: 'Cancelar',
  // Login
  'Recover password': 'Recuperar senha',
  'Forgot your password?': 'Esqueceu sua senha?',
  'Click here': 'Clique aqui',
  'Unable to log in. Please check if the email or password is correct.':
    'Não foi possível fazer o login. Verifique se o e-mail ou a senha estão corretos.',
  'User without permission/blocked. Contact the administrator.':
    'Usuário sem permissão/bloqueado. Procure o administrador do sistema.',
  'Error when trying to Login.': 'Erro ao tentar realizar o Login.',
  'Login successfully!': 'Login com sucesso!',
  Enter: 'Entrar',
  'Create an account': 'Criar uma conta',
  'Create account': 'Criar conta',
  'No account yet? ': 'Ainda não possui uma conta? ',

  // Two-Factor Authentication
  'We sent a code to': 'Enviamos um código para',
  'Code expires in': 'O código expira em',
  'Code expired. Request a new one.': 'Código expirado. Solicite um novo.',
  'attempts remaining': 'tentativas restantes',
  'Resend code in': 'Reenviar código em',
  'Resend code': 'Reenviar código',
  'Back to login': 'Voltar ao login',
  'Invalid code. Please try again.': 'Código inválido. Tente novamente.',
  'Error verifying code. Please try again.':
    'Erro ao verificar o código. Tente novamente.',
  'Connection error. Please try again.': 'Erro de conexão. Tente novamente.',
  'Account temporarily blocked. Try again in 15 minutes.':
    'Conta bloqueada temporariamente. Tente novamente em 15 minutos.',
  'New code sent to your email.': 'Novo código enviado para seu e-mail.',
  'Please wait before requesting a new code.':
    'Aguarde antes de solicitar um novo código.',
  'Error sending code. Please try again.':
    'Erro ao enviar o código. Tente novamente.',

  // Recover Password
  'Verification Code': 'Código de Verificação',
  'Check the code in your email.': 'Verifique o código no seu e-mail.',
  'Check if the email entered exists.':
    'Verifique se o e-mail inserido existe.',
  'Password recovery': 'Recuperação de senha',
  'Enter your email to receive the verification code.':
    'Insira seu e-mail para receber o código de verificação.',
  'Back to': 'Voltar para a página de',
  // Register
  Register: 'Cadastro',
  'Already have registration?': 'Já possui cadastro?',
  // Change Password
  'Password changed successfully!': 'Senha alterada com sucesso!',
  'The code has expired.': 'O código foi expirado.',
  'Exceeded number of attempts': 'Número de tentativas excedido',
  'Check that the entered code is valid.':
    'Verifique se o código inserido é válido.',
  'You will be redirected to the Login screen.':
    'Você será redirecionado para a tela de Login.',
  'Enter the verification code received in your email and enter your new password':
    'Insira o código de verificação recebido no seu e-mail e digite sua nova senha',
  Code: 'Código',
  'New Password': 'Nova senha',
  // Home
  'Search stations': 'Procure por estações',
  'Station started': 'Estação iniciada',
  Disconnected: 'Desconectado',
  Connected: 'Conectado',
  'Transaction Started': 'Transação iniciada',
  'Transaction Ended': 'Transação finalizada',
  Failure: 'Falha',
  'Short Recharge': 'Recarga de Pouca Duração',
  'In use': 'Em uso',
  'Total users': 'Total de usuários',
  Busy: 'Ocupado',
  Chargeboxes: 'Estações',
  Sustainability: 'Sustentabilidade',
  'Cultivated Tree': 'Árvore Cultivada',
  'Cultivated Trees': 'Árvores Cultivadas',
  'Estimated cost and revenue in the period':
    'Custo e receita estimada no período',
  Subtitles: 'Legendas',
  System: 'Sistema',
  'Admin Panel': 'Painel Admin',
  'General settings': 'Configurações gerais',
  Account: 'Conta',
  'View profile': 'Ver perfil',
  Logout: 'Logout',
  // Chargeboxes
  'Search by station name, state, city, or ID':
    'Procure por nome da estação, UF, cidade, ou ID',
  Report: 'Relatório',
  'Generate Station Report': 'Gerar Relatório de Estações',
  'Report Type': 'Tipo de Relatório',
  'Your plan is CVE lite. Each report type has a limit of {0} downloads per month. The counter is individual per type.':
    'Seu plano é CVE lite. Cada tipo de relatório tem um limite de {0} downloads por mês. O contador é individual por tipo.',
  'Unified Report': 'Relatório unificado',
  'Report by apartment': 'Relatório por apartamento',
  'Individual Report': 'Relatório individual',
  'Generate Report': 'Gerar Relatório',
  'Value Configuration': 'Configuração de Valores',
  'Download Excel': 'Download Excel',
  'New Station': 'Nova Estação',
  'All Accounts': 'Todas as Contas',
  'Select Account': 'Selecione a conta',
  'Unnamed Account': 'Conta sem nome',
  'All Chargebox Groups': 'Todos Grupos de Estações',
  Account: 'Conta',
  'Quantity of Recharges': 'Recargas (Qtde.)',
  Recharges: 'Recargas',
  Connectors: 'Conectores',
  'Edit Chargebox': 'Editar Estação',
  'Delete Chargebox': 'Deletar Estação',
  'Are you sure you want to delete this station? When deleting, all the history already made in it will be lost.':
    'Tem certeza que deseja deletar esta estação? Ao deletar será perdido todo o histórico já realizado nela.',
  Delete: 'Deletar',
  'You can only upload .jpg/.jpeg/.png file!':
    'Você só pode enviar arquivos .jpg/.jpeg/.png!',
  'Image must smaller than 10MB!': 'A imagem deve ser menor que 10MB!',
  'An image with this name already exists!':
    'Já existe uma imagem com este nome!',
  'Error uploading image!': 'Erro ao carregar a imagem!',
  // Form Chargebox
  General: 'Geral',
  'Creating Chargebox': 'Cadastro de Estação',
  'Editing Chargebox': 'Edição de Estação',
  'Address/Location': 'Endereço/Localização',
  Payment: 'Pagamento',
  'Hours of Operation': 'Horário de Funcionamento',
  'Access Control': 'Controle de Acesso',
  Owners: 'Proprietários',
  'Select users': 'Selecione os usuários',
  'Users with access': 'Usuários com acesso',
  'Owners can manage who can access the private station.':
    'Proprietários conseguem gerenciar quem pode acessar a estação privada.',
  'Users who only have access to the private station.':
    'Usuários que apenas possuem acesso à estação privada.',
  'The ChargeBox ID field is mandatory.': 'O campo ChargeBox ID é obrigatório.',
  'The ChargeBox ID field cannot contain blanks.':
    'O campo ChargeBox ID não pode conter espaços em branco.',
  'The Description field is mandatory.': 'O campo Descrição é obrigatório.',
  'The Type field cannot be null.': 'O campo Type não pode ser nulo.',
  'The Latitude field must be filled in.':
    'O campo Latitude deve ser preenchido.',
  'The Latitude field must be between -90 and 90.':
    'O campo Latitude deve ser entre -90 e 90.',
  'The Longitude field must be filled in.':
    'O campo Longitude deve ser preenchido.',
  'The Facial Reader MAC Address field is mandatory.':
    'O campo Leitor Facial Endereço MAC é obrigatório.',
  'Opening time must be defined': 'Horário de abertura deve ser definido',
  'Closing time must be defined': 'Horário de fechamento deve ser definido',
  'The connector type field cannot be null.':
    'O campo tipo do conector não pode ser nulo.',
  'Required field': 'Campo obrigatório',
  'Station created successfully!': 'Estação criada com sucesso!',
  'Station updated successfully!': 'Estação alterada com sucesso!',
  'Unable to perform the operation. Make sure the fields are filled in correctly.':
    'Não foi possível realizar a operação. Certifique-se de que os campos foram corretamente preenchidos.',
  'There is already a station registered with this identifier.':
    'Já existe uma estação cadastrada com este identificador.',
  Photos: 'Fotos',
  'User not found!': 'Usuário não encontrado!',
  'Please enter a valid CPF to continue.':
    'Por favor, preencha um CPF válido para continuar.',
  // Chargebox Groups
  'Chargebox Groups': 'Grupo de Estações',
  'Search by name': 'Procure por Nome',
  'Search by name, email, document or phone':
    'Procure por nome, e-mail, documento ou telefone',
  'New chargebox group': 'Novo Grupo de Estações',
  Address: 'Endereço',
  // Users
  User: 'Usuário',
  Users: 'Usuários',
  'New user': 'Novo Usuário',
  Car: 'Carro',
  'Recharges Done': 'Recargas Realizadas',
  'kWh Consumed': 'kWh Consumido',
  Document: 'Documento',
  'Active Users': 'Usuários Ativos',
  'Active Vehicles': 'Veículos Ativos',
  'Not registered': 'Não cadastrado',
  'The Name field is mandatory.': 'O campo Nome é obrigatório.',
  'The E-mail field is mandatory.': 'O campo E-mail é obrigatório.',
  'Invalid E-mail': 'E-mail inválido',
  'The Name field must only contain letters.':
    'O campo Nome deve conter apenas letras.',
  'The Password field is mandatory.': 'O campo Senha é obrigatório.',
  'The Phone field is mandatory.': 'O campo Telefone é obrigatório.',
  // Ocpp Tags
  'Tag ID': 'Identificação da Tag RFID',
  'Creating OCPP Tag': 'Cadastro de Tag RFID',
  'Editing OCPP Tag': 'Edição de Tag RFID',
  Owner: 'Proprietário',
  USER: 'USUÁRIO',
  CARD: 'CARTÃO',
  'Search By TAG ID': 'Procure por Tag IDs',
  'New OCPP Tag': 'Novo Tag RFID',
  'Ocpp Tag successfully deleted!': 'Tag RFID deletada com sucesso!',
  'Unable to delete Ocpp Tag.': 'Não foi possível deletar Tag RFID.',
  'Edit Ocpp Tag': 'Editar Tag RFID',
  'Delete Ocpp Tag': 'Deletar Tag RFID',
  'Are you sure you want to delete this Ocpp Tag? When deleting, all the history already made in it will be lost.':
    'Tem certeza de que deseja excluir este Tag RFID? Ao deletar, todo o histórico já feito nele será perdido.',
  'Does not own': 'Não possui',
  'Owner ID': 'Identificador do Proprietário',
  'Owner User': 'Proprietário',
  'Card User': 'Utilizador do Cartão',
  'OCPP Tag successfully created!': 'Tag RFID criada com sucesso!',
  'OCPP Tag successfully updated!': 'Tag RFID atualizado com sucesso!',
  'Inactivate Tag': 'Inativar Tag',
  // Unknown Ocpp Tags
  Attempts: 'Tentativas',
  'Last attempt': 'Última tentativa',
  'Station ID': 'ID da Estação',
  'Approve / Delete': 'Aprovar/ Deletar',
  Approve: 'Aprovar',
  'RFID Tag successfully approved!': 'Tag RFID aprovada com sucesso!',
  'Error when trying to approve RFID Tag': 'Erro ao tentar aprovar Tag RFID',
  'RFID Tag successfully deleted!': 'Tag RFID removida com sucesso!',
  'Error when trying to delete RFID Tag': 'Erro ao tentar remover Tag RFID',
  // Operations
  Operations: 'Operações',
  Commands: 'Comandos',
  Stations: 'Estações',
  Selected: 'Selecionado',
  'Charging Profiles': 'Perfis de Recarga',
  'Charging Profile PK': 'Perfil de Recarga ID',
  'Stack Level': 'Stack Level',
  'Profile Purpose': 'Propósito do Perfil',
  'Profile Kind': 'Tipo de Perfil',
  'Recurrency Kind': 'Tipo de Recorrência',
  'Valid From': 'Válido De',
  'Valid To': 'Válido Até',
  'Add new charging profile': 'Adicionar novo perfil de recarga',
  'Edit/ See Details': 'Alterar/Ver detalhes',
  'Identification Type': 'Tipo de Identificação',
  'Search to Select': 'Pesquise para selecionar',
  'Payment Type': 'Tipo de Pagamento',
  'Generate payment on recharge': 'Gerar pagamento na recarga',
  'Start Date/Time': 'Data e Hora de Início',
  'Stop Date/Time': 'Data e Hora de Parada',
  'Clear Cache': 'Limpar Cache',
  'Filter Type': 'Tipo de Filtro',
  'Charging Profile ID': 'ID do Perfil de Recarga',
  'Other Parameters': 'Outros Parâmetros',
  'Charging Profile Purpose': 'Propósito do Perfil de Recarga',
  'Stack Level (integer)': 'Nível de pilha (número inteiro)',
  'List Version': 'Versão da Lista',
  'Update Type': 'Tipo de Atualização',
  Full: 'Completa',
  Differential: 'Diferencial',
  'Search item to add/update': 'Buscar item para adicionar/atualizar',
  'Add to list': 'Adicionar à lista',
  'Add / Update List': 'Lista de Adição / Atualização',
  'One tag per line': 'Uma tag por linha',
  'Search item to delete': 'Buscar item para remover',
  'Delete List': 'Lista de Remoção',
  // Transactions
  Transactions: 'Transações',
  'All Tags': 'Todas Tags',
  'All Stations': 'Todas Estações',
  'All Revenue Status': 'Todos Status de Receita',
  'Search by ID or Station Name': 'Procure por ID ou Nome da Estação',
  'Recharge (ID)': 'Recarga (ID)',
  'Connector (ID)': 'Conector (ID)',
  Station: 'Estação',
  'User (Tag)': 'Usuário (Tag)',
  'Start - End': 'Início - Fim',
  Duration: 'Duração',
  'Income ($)': 'Receita (R$)',
  Energy: 'Energia',
  'Edit Payment': 'Editar Pagamento',
  'Unable to download the .xlsx file.':
    'Não foi possível fazer o download do arquivo .xlxs.',
  'The following transactions will have payment confirmed: ':
    'As Seguintes transações terão o pagamento confirmado: ',
  'Payments successfully confirmed!': 'Pagamentos confirmados com sucesso!',
  'Error when trying to confirm payments!':
    'Erro ao tentar confirmar pagamentos!',
  'Approve (': 'Aprovar (',
  ') Transactions': ') Transações',
  'Approve Transactions': 'Aprovar Transações',
  'Must select at least one transaction to perform action!':
    'Necessário selecionar ao menos uma transação para realizar ação!',
  'The query is limited to 10,000 transactions!':
    'A consulta está limitada a 10.000 transações!',
  'The report exceeds the allowed limit of {0} transactions. Adjust the filters and try again.':
    'O relatório excede o limite permitido de {0} transações. Ajuste os filtros e tente novamente.',
  // Indicators
  'All Users': 'Todos Usuários',
  Days: 'Dias',
  'Duration at last': 'Duração nos Últimos',
  'Recharges at last': 'Recargas nos Últimos',
  'Consumption at last': 'Consumo nos Últimos',
  'Autonomy at last': 'Autonomia nos Últimos',
  'Lenght of stay at last': 'Tempo de Permanência nos Últimos',
  'Most popular times at last': 'Horários mais Populares nos Últimos',
  'Registered Vehicle Brands': 'Marcas de Veículos Cadastrados',
  // Alerts
  Alerts: 'Alertas',
  'Search By Name or ChargeboxId (below the name)':
    'Procure pelo Nome ou ChargeBoxID (Abaixo do Nome)',
  Place: 'Local',
  Date: 'Data',
  Event: 'Evento',
  Undefined: 'Não Definido',
  // Push Notification
  'Send a Push Notification to users phone':
    'Envie um Push Notification no celular dos usuários',
  Message: 'Mensagem',
  // Support
  'Send us a message and we will get in touch':
    'Envie-nos uma mensagem que entraremos em contato',
  Subject: 'Assunto',
  'General Subjects': 'Assuntos gerais',
  Complaint: 'Reclamação',
  Suggestion: 'Sugestão',
  // Others
  'Empty list': 'Lista vazia',
  'There are no event records': 'Não há registros de eventos',
  'There are no chargebox records': 'Não há registros de estações',
  'There are no transaction records': 'Não há registros de transações',
  Autonomy: 'Autonomia',
  Error: 'Erro',
  Title: 'Título',
  'Creating Chargebox Group': 'Cadastro de Grupo de Estações',
  'Editing Chargebox Group': 'Edição de Grupo de Estações',
  'This website uses cookies to enhance the user experience':
    'Este website utiliza cookies para melhorar a sua experiência',
  'I Understand': 'Entendi',
  'Privacy Policy': 'Política de Privacidade',
  'By continuing, you agree to our': 'Ao continuar, você concorda com nossa',
  'Connector status': 'Estado do conector',
  Maintenance: 'Manutenção',
  Hidden: 'Oculto',
  connector_unavailable: 'Sem comunicação',
  Automatic: 'Automático',
  Consumption: 'Consumo',
  // Vouchers
  Vouchers: 'Vouchers',
  'Creating voucher': 'Criar voucher',
  'Complete selection': 'Concluir seleção',
  'No users selected': 'Nenhum usuário selecionado',
  'Select users for the voucher': 'Selecione usuários para o voucher',
  Guests: 'Convidados',
  Search: 'Pesquisar',
  // Dynamic Pricing
  'Pricing Profiles': 'Perfis de Preços',
  'Create profile': 'Criar perfil',
  'Profile name': 'Nome do perfil',
  'Fill in the profile name': 'Preencha o nome do perfil',
  'Read only': 'Somente leitura',
  'Edit exception': 'Editar exceção',
  'View exception': 'Visualizar exceção',
  'Read only — this profile is not available for editing.':
    'Somente leitura — este perfil não está disponível para edição.',
  Continue: 'Continuar',
  'No profiles found': 'Nenhum perfil encontrado',
  'applied charger': 'carregador aplicado',
  'applied chargers': 'carregadores aplicados',
  'Creating the profile': 'Criando o perfil',
  Monday: 'Segunda-feira',
  Tuesday: 'Terça-feira',
  Wednesday: 'Quarta-feira',
  Thursday: 'Quinta-feira',
  Friday: 'Sexta-feira',
  Saturday: 'Sábado',
  Sunday: 'Domingo',
  'Download log': 'Baixar log',
  'Clear filters': 'Limpar filtros',
  'Downloading logs for viewing...': 'Baixando logs para visualização...',
  'Select a date range to download old logs:':
    'Selecione um intervalo de datas para baixar logs antigos:',
  recent: 'recentes',
  'Downloading...': 'Baixando...',
  Financial: 'Financeiro',
  'Order by:': 'Ordenar por:',
  'Chronological order': 'Data da Recarga',
  'Financial movement': 'Data de Pagamento',
  'Error resending invoice!': 'Erro ao reenviar nota fiscal!',
  'Invoice resent successfully!': 'Nota fiscal reenviada com sucesso!',
  'Oops! It seems that something went wrong when issuing the invoice. Do you want to try again?':
    'Oops! Parece que algo não deu certo ao emitir a nota fiscal. Deseja tentar novamente?',
  Details: 'Detalhes',
  'Recharge composition': 'Composição da recarga',
  'All transactions': 'Todas movimentações',
  'Advanced Settings': 'Configurações Avançadas',
  'Create Configuration': 'Criar Configuração',
  'Edit Configuration': 'Editar Configuração',
  'Select chargers': 'Selecionar carregadores',
  Phase: 'Fase',
  Tension: 'Tensão (V)',
  'Charging Rate Unit': 'Unidade de carregamento',
  'Technical settings': 'Configurações técnicas',
  'Single Phase': 'Monofásico',
  'Two Phase': 'Bifásico',
  'Three Phase': 'Trifásico',
  'Add chargers': 'Adicionar carregador(es)',
  'Edit SmartCharging': 'Editar Smart Charging',
  'Create SmartCharging': 'Criar Smart Charging',
  Deposits: 'Depósitos',
  'The report is being generated and will be sent to the email registered in the system.':
    'O relatório está sendo gerado e será enviado para o e-mail cadastrado no sistema.',
  'Price calculation based on the energy of the transaction. For example: R$ 2.00/kWh':
    'Cálculo de preço com base na energia da transação. Por ex: R$ 2,00/kWh',
  'Price calculation based on the duration of the transaction. For example: R$ 1.00/minute.':
    'Cálculo de preço com base na duração da transação. Por ex: R$ 1,00/minuto',
  'Flat price per start. For example: R$ 5.00/start.':
    'Preço único por start realizado. Por ex: R$ 5,00/start',
  "Price based on the duration of the charger's idle time, i.e., the period after the transaction ends when the vehicle remains connected and occupying the charger (finishing state). For example: R$ 5.00/minute of finishing.":
    'Preço pela duração da ociosidade do carregador, ou seja, o período após a finalização da transação em que o veículo permanece conectado e ocupando o carregador (estado finishing). Por ex: R$ 5,00/minuto de finishing',
  'Flat price to use the reservation function. For example: R$ 5.00/reservation.':
    'Preço único para usar a função de reserva. Por ex: R$ 5,00/reserva',
  'System operation fee, to be applied after integrating the charging costs. For example: The final transaction amount is R$ 100.00, and the fee is 5%, so the operation fee should add R$ 5.00 to the final charging amount.':
    'Taxa de operação do sistema, deve ser aplicado após a integração dos custos da recarga. Por ex: O valor final da transação é de R$ 100,00, e a taxa é 5%, logo a taxa de operação deve adicionar R$ 5,00 no valor final da recarga.',
  'Tax fee, to be applied after integrating the charging costs. For example: The final transaction amount is R$ 100.00, and the tax is 15%, so the tax fee should add R$ 15.00 to the final charging amount.':
    'Taxa de imposotos, deve ser aplicado após a integração dos custos da recarga. Por ex: O valor final da transação é de R$ 100,00, e o imposto é 15%, logo a taxa de operação deve adicionar R$ 15,00 no valor final da recarga.',
  'Amount paid by the operator for energy consumption.':
    'Valor pago pelo operador referente ao consumo de energia.',
  Exception: 'Definir exceções',
  'Cancel Idle Payment': 'Cancelar pagamento ocioso',
  'Idle Payment Canceled': 'Pagamento ocioso cancelado',
  'Idle payment canceled successfully!':
    'Pagamento ocioso cancelado com sucesso',
  'Confirm cancelation of idle payment?':
    'Confirmar o cancelamento do pagamento ocioso?',
  'Disabled Stations': 'Estações Desabilitadas',
  Current: 'Corrente (A)',
  Power: 'Potência (W)',
  // OCPI: chave própria, a 'Power' global diz (W) e a potência do conector é exibida em kW.
  'Connector power': 'Potência',
  Intervals: 'Períodos',
  Beginning: 'Início',
  End: 'Final',
  'Charging Profile created successfully':
    'Charging Profile criado com sucesso',
  'Charging Profile updated successfully':
    'Charging Profile alterado com sucesso',
  'is required': 'é obrigatório',
  'Current Limit (A)': 'Limite de corrente (A)',
  'Intervals cannot overlap and must be in chronological order':
    'Os intervalos não podem se sobrepor e devem estar em ordem cronológica',
  'Current Limit must be different from Default Limit':
    'O limite de corrente atual deve ser diferente do limite de corrente padrão',
  'Confirm exclusion': 'Confirmar exclusão',
  'When deleting the Pricing Profile': 'Ao deletar o Perfil de Preço',
  ', it will be unlinked from all chargers.':
    ', ele será desvinculado de todos os carregadores.',
  'Are you sure?': 'Tem certeza?',
  No: 'Não',
  'Failed to delete the Pricing Profile': 'Falha ao deletar o Perfil de Preço',
  'Error deleting the Pricing Profile:': 'Erro ao deletar o Perfil de Preço',
  'Pricing Profile deleted successfully':
    'Sucesso ao deletar o Perfil de Preço',
  '8 to 25 characters': '8 a 25 caracteres',
  'At least one uppercase letter': 'Pelo menos uma letra maiúscula',
  'At least one lowercase letter': 'Pelo menos uma letra minúscula',
  'At least one special character': 'Pelo menos um caractere especial',
  'At least one number': 'Pelo menos um número',
  'New vehicle': 'Novo veículo',
  Company: 'Empresa',
  'Creating company': 'Cadastro de empresa',
  'Sap Code': 'Código SAP',
  'Update Company': 'Atualizar Empresa',
  'Create Company': 'Criar Empresa',
  'Edit Company': 'Editar Empresa',
  'Failed to load the company!': 'Não foi possível carregar a empresa!',
  'Go back': 'Voltar',
  'Try again': 'Tentar novamente',
  'Failed to update the company!': 'Falha ao atualizar empresa!',
  'Company updated successfully!': 'Empresa atualizada com sucesso!',
  'The license plate field is mandatory.': 'O campo placa é obrigatório.',
  'The Company field is mandatory.': 'O campo empresa é obrigatório.',
  'Search by car license plate or company': 'Procure por placa ou empresa',
  'When deleting the Company': 'Ao deletar a Empresa',
  ', It will be unlinked from all users':
    ', ela será desvinculada de todos os usuários.',
  'Company deleted successfully': 'Empresa deletada com sucesso',
  'Error deleting the Company': 'Erro ao deletar a empresa',
  'No company': 'Sem Empresa',
  'Failed to create company.': 'Falha ao criar empresa',
  'The company name field is required.':
    'O campo nome da empresa é obrigatório.',
  'The NIT field is required.': 'O campo NIT é obrigatório.',
  'The Sap Code field is required.': 'O campo nome da empresa é obrigatório.',
  'No results found': 'Nenhum resultado encontrado',
  'Trusted user': 'Usuário confiável',
  'High risk': 'Alto risco',
  'Medium risk': 'Médio risco',
  'Low risk': 'Baixo risco',
  'No score': 'Sem pontuação',
  'Loading score': 'Carregando pontuação',
  'Card': 'Cartão',
  'No card': 'Sem cartão',
  'Score unavailable': 'Score indisponível',
  'By selecting this option, the system will skip credit card authenticity verification for this user.':
    'Ao marcar esta opção, o sistema ignora a verificação de autenticidade do cartão de crédito para este usuário.',
  'Mark as trusted user': 'Marcar como usuário confiável',
  'By marking this user as trusted, you will be assuming the risks of possible fraud associated with this account.':
    'Ao marcar o usuário como confiável, você estará assumindo os riscos de possíveis fraudes associadas a esta conta.',
  Vehicles: 'Veículos',
  'Editing Vehicle': 'Editando veículo',
  'Edit Vehicle': 'Editar veículo',
  Block: 'Bloco',
  Apartment: 'Apartamento',
  'Report by apartment': 'Relatório por apartamento',
  'License code': 'Código da licença',
  'The License Code field is mandatory.':
    'O campo Código da licença é obrigatório.',
  'The License Code is expired.': 'O Código da licença expirou.',
  'Duration (in minutes) after which the idle time pricing will be applied.':
    'Duração (em minutos) após a qual o preço de tempo ocioso será aplicado.',
  'Beneficiary Accounts': 'Contas Favorecidas',
  'Data and BI': 'Dados e BI',
  'Create Account': 'Criar Conta',
  'Provide a value for income': 'Forneça um valor para receita',
  'Provide a valid CPF/CNPJ': 'Forneça um CPF/CNPJ válido',
  'Provide a value for cost': 'Forneça um valor para custo',
  'Client CPF/CNPJ': 'Cliente (CPF/CNPJ)',
  'Idle Charging Cost': 'Taxa de Ociosidade',
  'Enable Idle Charging': 'Habilitar cobrança de ociosidade',
  'Need different values per connector?':
    'Precisa de valores diferentes por conector?',
  'Configure individually': 'Configurar individualmente',
  'Get Composite Schedule': 'Obter Cronograma Composto',
  '0 = charge point as a whole': '0 = carregador como um todo',
  '-- Empty --': '-- Vazio --',
  'Duration (in seconds)': 'Duração (em segundos)',
  'Schedule Start': 'Início do Cronograma',
  'Start Schedule': 'Início do Cronograma de Carga',
  'Min Charging Rate': 'Taxa Mínima de Carregamento',
  'Start Period (in sec)': 'Início do Período (em seg)',
  'Number Phases': 'Número de Fases',
  'Change statement value': 'Alterar valor do extrato',
  'Add value': 'Adicionar valor',
  'Remove value': 'Remover valor',
  'Enter a value greater than zero': 'Informe um valor maior que zero',
  'Operation type': 'Tipo de operação',
  'The value will be added to the balance': 'O valor será somado ao saldo',
  'The value will be subtracted from the balance':
    'O valor será subtraído do saldo',
  Confirm: 'Confirmar',
  'Ex: 10,00': 'Ex: 10,00',
  'Balance updated successfully': 'Saldo atualizado com sucesso',
  'Failed to update balance': 'Falha ao atualizar o saldo',
  'Wallet changed for': 'Carteira alterada de',
  'Changed by': 'Alteração feita por',
  'Failed to load': 'Erro ao carregar',
  'Stop charging': 'Parar recarga',
  'Are you sure you want to force-stop the charging?\n\nBefore continuing, try using the "Stop charging" command in Operations. By forcing the stop, the charging will be finalized with the values measured so far.':
    'Tem certeza de que deseja forçar o encerramento da recarga?\n\nAntes de continuar, tente utilizar o comando "Parar Recarga" em Operações. Ao forçar o encerramento, a recarga será finalizada com os valores medidos até o momento.',
  'Charging stopped successfully!': 'Recarga parada com sucesso!',
  'Failed to stop charging.': 'Falha ao parar a recarga.',
  // Interoperability tour (MV2-1791)
  'See the tour again': 'Ver tutorial novamente',
  'Back': 'Voltar',
  'Next step': 'Próximo passo',
  'Got it': 'Entendi',
  'Skip tour': 'Pular tutorial',
  'What this module does': 'O que este módulo faz',
  'Interoperability lets two accounts share the visibility of their stations. The tabs follow the order of the process, left to right, and this tour walks through them in that order.': 'A Interoperabilidade permite que duas contas compartilhem a visualização das estações uma da outra. As abas seguem a ordem do processo, da esquerda para a direita, e este tutorial passa por elas nessa ordem.',
  'Eligibility is the gate': 'A elegibilidade é o portão',
  'Nothing else works before this: the account and the sub-accounts you choose need to be eligible to bind. Turning it on opens data replication to the interoperability service, which is why it is behind its own permission.': 'Nada mais funciona antes disto: a conta e as subcontas que você escolher precisam estar elegíveis para se vincular. Ligar abre a replicação de dados para o serviço de interoperabilidade, e é por isso que fica atrás de uma permissão própria.',
  'An accepted invite becomes a contract': 'Convite aceito vira contrato',
  'Here are the contracts already in force, with who and in which direction. Bidirectional means both sides see each other — it depends on the partner having an app of their own. One-way means only one side sees. The same contracts also show as a map of links.': 'Aqui estão os contratos em vigor, com quem e em qual direção. Bidirecional significa que os dois lados se veem — depende de o parceiro ter aplicativo próprio. Unilateral significa que só um lado vê. Os mesmos contratos também aparecem como um mapa de ligações.',
  'What the contract delivers': 'O que o contrato entrega',
  'The stations the contract made visible to you, and the ones you made visible to the partner. This is the tab that shows the result of everything above.': 'As estações que o contrato tornou visíveis para você, e as que você tornou visíveis para o parceiro. É a aba que mostra o resultado de tudo o que vem antes.',
  'Charges across accounts': 'Recargas entre contas',
  'Charging sessions your drivers ran on partner stations, and the ones partner drivers ran on yours.': 'As recargas que os seus motoristas fizeram em estações do parceiro, e as que os motoristas do parceiro fizeram nas suas.',
  'Who changed what': 'Quem mudou o quê',
  'Every change to eligibility, invites and contracts, with author and date. Use it to answer why a partner stopped seeing your stations.': 'Toda alteração de elegibilidade, convites e contratos, com autor e data. Use para responder por que um parceiro deixou de ver as suas estações.',
  'For whoever integrates a system': 'Para quem vai integrar um sistema',
  'Account settings, not day-to-day operation: the access key and the endpoint documentation, for reading this same data from outside the dashboard.': 'Configuração da conta, e não operação do dia: a chave de acesso e a documentação dos endpoints, para ler estes mesmos dados de fora do dashboard.',
  // Interoperability tour - fluxo de convite (MV2-1791)
  'Tutorial': 'Tutorial',
  'Invite and token flow': 'Fluxo de convite e token',
  'First, your account token': 'Primeiro, o token da sua conta',
  'This token is the address of your account: you hand it to a partner so they are able to invite you. It is not the invite itself — it can be shown again and renewed whenever you want, and whoever holds it can only invite you. Accepting is always your own act.': 'Este token é o endereço da sua conta: você o entrega a um parceiro para que ele consiga convidar você. Ele não é o convite — pode ser reexibido e renovado quando você quiser, e quem tem ele só consegue convidar você. Aceitar é sempre ato seu.',
  'Inviting starts with the partner token': 'Convidar começa pelo token do parceiro',
  'Ask the partner for the token on their own Interoperability screen, paste it here and check it. The check tells you whether that account has an app configured: with no app it does not display stations, so only the one-way contract is possible. Then you pick which of your accounts enter the contract and how long the invite stays valid.': 'Peça ao parceiro o token que aparece na tela de Interoperabilidade dele, cole aqui e verifique. A verificação diz se aquela conta tem aplicativo configurado: sem aplicativo ela não exibe estações, então só cabe o contrato unilateral. Depois você escolhe quais das suas contas entram no contrato e por quanto tempo o convite vale.',
  'The invite token is a different one': 'O token do convite é outro',
  'Generating the invite produces a second token: single use, shown only once and kept only as a hash, so it cannot be recovered. Send it to the partner through a safe channel. On the receiving side it is pasted right here, in "Enter token", where the summary says how many accounts and stations the contract shares before it is authorized.': 'Gerar o convite produz um segundo token: de uso único, exibido uma única vez e guardado apenas como hash, ou seja, não há como recuperá-lo. Envie-o ao parceiro por um canal seguro. Do lado de quem recebe, ele é colado exatamente aqui, em "Inserir token", onde o resumo diz quantas contas e quantas estações o contrato compartilha antes de a pessoa autorizar.',
  'A received invite waits here': 'Convite recebido espera aqui',
  'When someone invites you, the notice shows up at the top of the screen with the time left, and "Review invite" opens the acceptance straight away — no need to hunt for the token in your e-mail.': 'Quando alguém convida você, o aviso aparece no alto da tela com o prazo restante, e "Revisar convite" abre o aceite direto — sem precisar procurar o token no e-mail.',
  'Every invite, in both directions': 'Todos os convites, nos dois sentidos',
  'The ones you sent and the ones you received, with what became of each: pending, used, expired or revoked. A pending invite can still be revoked; an expired one cannot be reused, and connecting that partner takes a new invite.': 'Os que você enviou e os que você recebeu, com o que aconteceu com cada um: pendente, usado, expirado ou revogado. Convite pendente ainda pode ser revogado; expirado não se reaproveita, e conectar aquele parceiro exige um convite novo.',
  'This module is not available for your account.': 'Este módulo não está disponível para a sua conta.',
  'Your account does not have access to this area. Talk to the administrator if you need it.': 'Sua conta não tem acesso a esta área. Fale com o administrador se precisar dele.',
  'Back to home': 'Voltar para o início',
  'There is already an active invite for this partner. To generate a new one, revoke the previous one on the Invites tab.': 'Já existe um convite ativo para este parceiro. Para gerar um novo, revogue o anterior na aba Convites.',
  'Do not charge idle time': 'Não cobrar ociosidade',
  'Idle charging 24 hours': 'Cobrar ociosidade 24 horas',
  'Customize idle exemption per day': 'Personalizar isenção por dia',
  'Charge idle time all day': 'Cobrar ociosidade o dia todo',
  'Idle exemption description': 'Configura os horários em que não haverá cobrança de ociosidade em cada dia da semana',
  'Idle exemption always charge empty state': 'Cobrança de ociosidade ativa 24 horas, todos os dias',
  'Idle exemption inactive empty state': 'Ative "Personalizar por dia" para configurar horários diferentes em cada dia',
  'Idle exemption hint prefix': 'Das',
  'Idle exemption hint separator': 'às',
  'Idle exemption hint suffix': 'a ociosidade não será cobrada',
  'Use custom idle exemption per connector': 'Usar horário próprio (senão, herda da estação)',
  'Per-connector idle exemption overrides': 'Overrides de isenção por conector',
  'Idle exemption periods overlap': 'Faixas se sobrepõem no mesmo dia',
  'Approve manually': 'Aprovar manualmente',
  'Charge wallet': 'Cobrar da carteira',
  'Charge credit card': 'Cobrar do cartão de crédito',
  'Confirm manual approval?': 'Aprovar pagamento manualmente?',
  'Manual approval description':
    'A transação será marcada como paga manualmente. Esta ação será registrada em auditoria.',
  'Confirm card charge?': 'Cobrar do cartão?',
  'Card charge description':
    'Vamos tentar capturar a pré-autorização existente. Se não for possível, faremos uma nova cobrança. Continuar?',
  'Charge wallet title': 'Cobrar da carteira',
  'Wallet balance insufficient':
    'Saldo insuficiente (faltam R$ {value}). A cobrança pela carteira está bloqueada.',
  'Wallet with open pre-auth':
    'Há uma pré-autorização aberta no cartão do cliente. Ao confirmar, ela será cancelada.',
  'Manual action success': 'Operação realizada com sucesso',
  'Manual action failure': 'Falha na operação',
  'Charge succeeded': 'Cobrança realizada com sucesso',
  'Wallet charged but pre-auth cancel failed': 'Cobrança da carteira realizada, mas o cancelamento da pré-autorização no cartão falhou. Verifique e cancele manualmente no PagBank.',
  'Approved manually': 'Pagamento aprovado manualmente',
  'Card charged': 'Cobrança aprovada no cartão',
  // M24: rótulos do WalletChargeConfirmationModal
  Balance: 'Saldo',
  Amount: 'Valor',
  'Audit Log': 'Log de Auditoria',
  'Change history in the system': 'Histórico de alterações realizadas no sistema',
  'Change type': 'Tipo de alteração',
  'What changed': 'O que foi alterado',
  'Where': 'Onde foi alterado',
  'Changes in period': 'Alterações no período',
  'Last change': 'Última alteração',
  'Audit records': 'Registros de auditoria',
  'All types': 'Todos os tipos',
  'Filter': 'Filtrar',
  'Clear': 'Limpar',
  'Record details': 'Detalhes do registro',
  'View details': 'Ver detalhes',
  'Could not load the audit records': 'Não foi possível carregar os registros de auditoria',
  'Could not load the change types': 'Não foi possível carregar os tipos de alteração',
  'User document': 'Documento do usuário',
  'Wallet balance': 'Saldo da carteira',
  'Manual charge stop': 'Parada manual de recarga',
  'Charger type': 'Tipo do carregador',
  'Charger firmware': 'Firmware do carregador',
  'Station edit': 'Edição de estação',
  'Price profile edit': 'Edição de perfil de preço',
  'Advanced configuration edit': 'Edição de configuração avançada',
  'Connector door opening': 'Abertura de porta do conector',
  'Access door': 'Porta de acesso',
  Connector: 'Conector',
  'Door disabled': 'Desativado',
  'Door not configured': 'Sem configuração',
  Configured: 'Configurado',
  'Each connector has its own door.': 'Cada conector tem sua própria porta.',
  'Could not load the door settings.': 'Não foi possível carregar a configuração da porta.',
  'Discard changes?': 'Descartar alterações?',
  'The changes to this connector have not been saved.': 'As alterações deste conector não foram salvas.',
  Discard: 'Descartar',
  'This connector has door unlock': 'Este conector tem destravamento de porta',
  'When enabled, enables remote opening settings and the unlock button in the driver app': 'Quando ativado, habilita a configuração de abertura remota e o botão de destravar no app do motorista',
  'How it opens': 'Como abre',
  'Opening method': 'Método de abertura',
  'HTTP call (webhook)': 'Chamada HTTP (webhook)',
  'Opening is always triggered by someone, from the button in the app or from the dashboard, never by a reader on the equipment.': 'A abertura é sempre disparada por alguém, pelo botão no app ou pelo dashboard, nunca por leitor no equipamento.',
  'HTTP call': 'Chamada HTTP',
  Timeout: 'Timeout',
  '{0} s (system default)': '{0} s (padrão do sistema)',
  'Test connection': 'Testar conexão',
  'Open door now': 'Abrir porta agora',
  'Save your changes before opening the door.': 'Salve as alterações antes de abrir a porta.',
  'Last opening': 'Última abertura',
  'No opening recorded.': 'Nenhuma abertura registrada.',
  'Last 10 openings': 'Últimas 10 aberturas',
  View: 'Ver',
  Close: 'Fechar',
  'Could not load the opening history.': 'Não foi possível carregar o histórico de aberturas.',
  'Driver app': 'App do motorista',
  Dashboard: 'Dashboard',
  'Door settings saved.': 'Configuração da porta salva.',
  'Check the highlighted fields.': 'Verifique os campos destacados.',
  'Open the door now?': 'Abrir a porta agora?',
  'This will unlock the access door of this connector.': 'Isso vai destravar a porta de acesso deste conector.',
  'Open door': 'Abrir porta',
  'Unsaved changes do not apply to this opening.': 'As alterações não salvas não valem para esta abertura.',
  'The settings on screen will be used for this opening, without saving.': 'A abertura usa a configuração da tela, sem salvar.',
  'The access door of connector {0} was not saved: {1}': 'A porta de acesso do conector {0} não foi salva: {1}',
  'Copy from connector {0}': 'Copiar do conector {0}',
  'No attempt in this session': 'Nenhuma tentativa nesta sessão',
  'Request failed': 'Falha na requisição',
  'Timed out': 'Tempo esgotado',
  'Network error': 'Erro de rede',
  'Enter the controller URL': 'Digite a URL do controlador',
  Headers: 'Cabeçalhos',
  Key: 'Chave',
  'Description (optional)': 'Descrição (opcional)',
  'JSON body': 'Corpo da mensagem',
  'Enter the request body in JSON': 'Digite o corpo da requisição em JSON',
  'Variables:': 'Variáveis:',
  'The URL field is mandatory.': 'O campo URL é obrigatório.',
  'The URL must start with http:// or https://.': 'A URL deve começar com http:// ou https://.',
  'The body is not valid JSON.': 'O corpo não é um JSON válido.',
  'The header key is mandatory.': 'A chave do cabeçalho é obrigatória.',
  'The header value is mandatory.': 'O valor do cabeçalho é obrigatório.',
  'HTTP method': 'Método HTTP',
  'Controller URL': 'URL do controlador',
  'Door settings saved, but the status could not be refreshed.': 'Configuração da porta salva, mas não foi possível atualizar o status.',
  'The door was triggered, but the last opening could not be refreshed.': 'A porta foi acionada, mas não foi possível atualizar a última abertura.',
  'Unexpected code {0}': 'Código inesperado {0}',
  'Test sent: {0}': 'Teste enviado: {0}',
  'Door opened: {0}': 'Porta aberta: {0}',
  'Test failed: {0}': 'Teste falhou: {0}',
  'Opening failed: {0}': 'Falha ao abrir: {0}',
  'Connection checked in {0} ms.': 'Conexão verificada em {0} ms.',
  'Synchronous call completed in {0} ms.': 'Disparo síncrono concluído em {0} ms.',
  'Remove header': 'Remover cabeçalho',
  Save: 'Salvar',
  'Door enabled': 'Ativado',
  'Door unlock is not configured for this connector': 'Destravamento de porta não configurado para este conector.',
  'URL is required': 'A URL é obrigatória.',
  'URL must start with http:// or https://': 'A URL deve começar com http:// ou https://.',
  'Body is not a valid JSON': 'O corpo não é um JSON válido.',
  'Header key is required': 'A chave do cabeçalho é obrigatória.',
  'Header value is required': 'O valor do cabeçalho é obrigatório.',
  'Header key has invalid characters': 'A chave do cabeçalho tem caracteres inválidos.',
  'Header value has invalid characters': 'O valor do cabeçalho tem caracteres inválidos.',
  'Charge point not found': 'Estação não encontrada.',
  'Connector not found': 'Conector não encontrado.',
  'Invalid URL': 'URL inválida.',
  'Invalid header': 'Cabeçalho inválido.',
  'Destination not allowed': 'Destino não permitido.',
  'Call interrupted': 'Chamada interrompida.',
  'The controller did not respond in time': 'O controlador não respondeu a tempo.',
  'Device ID': 'Device ID',
  'Enter the controller DEVICE_ID': 'Digite o DEVICE_ID do controlador',
  'The Device ID field is mandatory.': 'O campo Device ID é obrigatório.',
  "The Device ID may only have letters, digits, '_' and '-'.": "O Device ID só pode ter letras, números, '_' e '-'.",
  'The body is mandatory.': 'O corpo é obrigatório.',
  'Unexpected response': 'Resposta inesperada',
  'Device ID is required': 'O Device ID é obrigatório.',
  "Device ID may only have letters, digits, '_' and '-'": "O Device ID só pode ter letras, números, '_' e '-'.",
  'Body is required': 'O corpo é obrigatório.',
  'RabbitMQ is disabled on this server': 'O RabbitMQ está desligado neste servidor.',
  'Could not reach the message broker': 'Não foi possível conectar ao RabbitMQ.',
  'Could not connect to the controller': 'Não foi possível conectar ao controlador.',
  'Too many door calls at the same time, try again in a moment': 'Muitas chamadas ao mesmo tempo. Tente novamente em instantes.',
  'A door opening is already in progress for this connector': 'Já existe uma abertura em andamento neste conector.',
  // MV2-1974 módulo OCPI
  'All': 'Todas',
  'All charges made at the stations published via OCPI, by partner users or not. The partner of each charge is not identified.': 'Todas as recargas feitas nas estações publicadas via OCPI, de usuários de parceiros ou não. O parceiro de cada recarga não é identificado.',
  'All states': 'Todas as UFs',
  'All statuses': 'Todos os status',
  'Amount': 'Valor',
  'Average duration': 'Duração média',
  'Back': 'Voltar',
  'Billed in the period': 'Faturado no período',
  'Blocked': 'Bloqueada',
  'CDR': 'CDR',
  'CDR available': 'CDR disponível',
  'CDR of charge': 'CDR da recarga',
  'CDRs in the period': 'CDRs no período',
  'Charge': 'Recarga',
  'Charge data': 'Dados da recarga',
  'Charges': 'Recargas',
  'Charges at this station in the period': 'Recargas nesta estação no período',
  'Charges in progress': 'Recargas em andamento',
  'Check whether the partner has already sent the token.': 'Confira se o parceiro já enviou o token.',
  'Completed': 'Concluída',
  'Connector': 'Conector',
  'Connector status now': 'Status dos conectores agora',
  'Coordinates': 'Coordenadas',
  'Could not load the OCPI data. Try again in a few minutes.': 'Não foi possível carregar os dados OCPI. Tente de novo em alguns minutos.',
  'Could not look up the token. Try again in a few minutes.': 'Não foi possível consultar o token. Tente de novo em alguns minutos.',
  'Currency': 'Moeda',
  'E.g.: 04A2B7719C81': 'Ex.: 04A2B7719C81',
  'Ended': 'Encerrada',
  'Ended without consumption': 'Encerrada sem consumo',
  'Energy in the period': 'Energia no período',
  'Enter the UID of the token the partner sent to see the linked tag in the CS.': 'Informe o UID do token que o parceiro enviou para ver a tag vinculada no CS.',
  'Error reported by the station': 'Erro informado pela estação',
  'Generated when it ends': 'Gerado ao encerrar',
  'Idle fee': 'Ociosidade',
  'In OCPI, each connector is published as an EVSE.': 'No OCPI, cada conector é publicado como uma EVSE.',
  'In progress': 'Em andamento',
  'Inoperative': 'Inoperante',
  'Invalid': 'Inválida',
  'Invalid charges do not generate a CDR': 'Recarga inválida não gera CDR',
  'Last 30 days': 'Últimos 30 dias',
  'Last 7 days': 'Últimos 7 dias',
  'List': 'Lista',
  'Location': 'Local',
  'Location (address_pk)': 'Local (address_pk)',
  'Look up': 'Consultar',
  'Look up OCPI token': 'Consultar token OCPI',
  'Look up token': 'Consultar token',
  'Map': 'Mapa',
  'No CDR': 'Sem CDR',
  'No CDRs in the period.': 'Não há CDRs no período.',
  'No OCPI token with the UID': 'Nenhum token OCPI com o UID',
  'No charges at this station in the period.': 'Não há recargas nesta estação no período.',
  'No charges in the period.': 'Não há recargas no período.',
  'No fee': 'Sem taxa',
  'No photos': 'Sem fotos',
  'No station is marked as OCPI compatible in this account yet.': 'Nenhuma estação desta conta está marcada como compatível com OCPI.',
  'No station with these filters.': 'Nenhuma estação com esses filtros.',
  'OCPI UID': 'UID OCPI',
  'Out of order': 'Fora de operação',
  'Overview': 'Visão geral',
  'Pending': 'Pendente',
  'Per kWh': 'Por kWh',
  'Per minute': 'Por minuto',
  'Period (start date)': 'Período (data de início)',
  'Planned': 'Planejada',
  'Published stations': 'Estações publicadas',
  'Recent charges': 'Recargas recentes',
  'Registered on': 'Cadastrada em',
  'Removed': 'Removida',
  'Reservation': 'Reserva',
  'Showing the first': 'Mostrando as primeiras',
  'Start': 'Início',
  'Start → end': 'Início → fim',
  'Started': 'Iniciada',
  'Station ID, UUID, address or city': 'ID da estação, UUID, endereço ou cidade',
  'Stations published via OCPI and the charges made on them.': 'Estações publicadas via OCPI e as recargas feitas nelas.',
  'Stations with the most energy in the period': 'Estações com mais energia no período',
  'Status': 'Status',
  'Suspended by station': 'Suspenso pela estação',
  'Suspended by vehicle': 'Suspenso pelo veículo',
  'Tag': 'Tag',
  'Tag in the CS': 'Tag no CS',
  'Timeline': 'Linha do tempo',
  'Today': 'Hoje',
  'Token UID': 'UID do token',
  'Total': 'Total',
  'Unknown': 'Desconhecido',
  'Updated on': 'Atualizado em',
  'View CDR': 'Ver CDR',
  'View charge': 'Ver recarga',
  'View station': 'Ver estação',
  'Waiting to start': 'Aguardando início',
  'charges': 'recargas',
  'connectors': 'conectores',
  'ongoing': 'em andamento',
  'Connector faulted': 'Com falha',
  'Connector finishing': 'Finalizando',
  'Connector unavailable': 'Indisponível',
  'Charge period': 'Período',
  'since': 'desde',
  'started in the period': 'iniciadas no período',
  'stations': 'estações',
  'up to': 'até',
  'with a faulted or unavailable connector': 'com conector em falha ou indisponível',
  // MV2-1974 módulo OCPI: recebidas como parceiro
  'Received as partner': 'Recebidas como parceiro',
  'Could not load the stations received as a partner.': 'Não foi possível carregar as estações recebidas como parceiro.',
  'This account has no external id in the cross, so it does not receive stations as a partner.': 'Esta conta não tem external id no cross, então não recebe estações como parceiro.',
  'Stations this account receives as a partner (eMSP) through the bindings in the cross. It is the same list the OCPI service uses to build the partner /locations.': 'Estações que esta conta recebe como parceiro (eMSP) pelos vínculos no cross. É a mesma lista que o serviço OCPI usa para montar o /locations do parceiro.',
  'Account in the cross': 'Conta no cross',
  'external id': 'external id',
  'Stations received': 'Estações recebidas',
  'operators': 'operadores',
  'Go into the feed': 'Entram no feed',
  'with address, coordinates and operator': 'com endereço, coordenadas e operador',
  'Discarded by the OCPI': 'Descartadas pelo OCPI',
  'never reach the partner': 'nunca chegam ao parceiro',
  'The cross returned more pages than the dashboard reads. Only the first ones are shown.': 'O cross devolveu mais páginas do que o dashboard lê. Só as primeiras aparecem.',
  'No station is bound to this account as a partner.': 'Nenhuma estação está vinculada a esta conta como parceiro.',
  'By operator': 'Por operador',
  'Operator': 'Operador',
  'Feed': 'Feed',
  'Discarded': 'Descartada',
  'Goes into the feed': 'Entra no feed',
  'No operator name': 'Sem nome do operador',
  'No address': 'Sem endereço',
  'No coordinates': 'Sem coordenadas',
  'Click an operator to see only its stations.': 'Clique num operador para ver só as estações dele.',
  'Search operator': 'Buscar operador',
  'No operator with this name.': 'Nenhum operador com esse nome.',
  'Station code, description, address or city': 'Código, descrição, endereço ou cidade da estação',
  'All operators': 'Todos os operadores',
  'Stations this account sends and receives via OCPI, and the charges made on the ones it sends.': 'Estações que esta conta envia e recebe via OCPI, e as recargas feitas nas que ela envia.',
  'Sent stations': 'Estações enviadas',
  'Received stations': 'Estações recebidas',
  'This account does not receive stations as a partner.': 'Esta conta não recebe estações como parceiro.',
  'go into the feed': 'entram no feed',
  'discarded': 'descartadas',
  'Sending': 'Enviando',
  'Stations of this account that the partners see': 'Estações desta conta que os parceiros veem',
  'with a faulted connector': 'com conector em falha',
  'View sent stations': 'Ver estações enviadas',
  'Receiving': 'Recebendo',
  'Stations of other operators bound to this account in the cross': 'Estações de outros operadores vinculadas a esta conta no cross',
  'View received stations': 'Ver estações recebidas',
  'Charges at the stations this account sends': 'Recargas nas estações que esta conta envia',
  'Receiving as partner (eMSP)': 'Recebendo como parceiro (eMSP)',
  'Stations of other operators bound to this account in the cross. It is the same list the OCPI service uses to build the partner /locations.': 'Estações de outros operadores vinculadas a esta conta no cross. É a mesma lista que o serviço OCPI usa para montar o /locations do parceiro.',
  'Green goes into the feed, red is discarded by the OCPI. Stations without coordinates do not appear on the map.': 'Verde entra no feed, vermelho é descartada pelo OCPI. Estações sem coordenadas não aparecem no mapa.',
  'Sending as operator (CPO)': 'Enviando como operador (CPO)',
  'Stations of this account that the OCPI service publishes to the partners: public and marked as OCPI compatible.': 'Estações desta conta que o serviço OCPI publica para os parceiros: públicas e marcadas como compatíveis com OCPI.',
  'Why the OCPI discards it': 'Por que o OCPI descarta',
  'Open in Google Maps': 'Abrir no Google Maps',
  'Close': 'Fechar',
  'Online': 'Online',
  'Offline': 'Offline',
  'Reason': 'Motivo',
  'The OCPI service leaves this station out of the partner /locations until the data is fixed in the operator account.': 'O serviço OCPI deixa esta estação fora do /locations do parceiro até o dado ser corrigido na conta do operador.',
  'The partner receives this station in /locations. In OCPI, each connector is published as an EVSE.': 'O parceiro recebe esta estação no /locations. No OCPI, cada conector é publicado como uma EVSE.',
  'Connection': 'Conexão',
  'No connector registered.': 'Nenhum conector cadastrado.',
  'The partners receive this station in /locations. In OCPI, each connector is published as an EVSE.': 'Os parceiros recebem esta estação no /locations. No OCPI, cada conector é publicado como uma EVSE.',
  'ZIP code': 'CEP',
  'Since': 'Desde',
  'Showing only': 'Mostrando só',
  'Minimized. Expand to filter by operator.': 'Minimizado. Expanda para filtrar por operador.',
  'Expand': 'Expandir',
  'Minimize': 'Minimizar',
  'Sending and receiving': 'Enviando e recebendo',
  Tickets: 'Chamados',
  'Tickets (Internal)': 'Chamados (Interno)',
  'You do not have access to this area': 'Você não tem acesso a esta área',
  'Open ticket': 'Abrir chamado',
  'Open tickets': 'Abertos',
  'Resolved tickets': 'Resolvidos',
  'Filter by company': 'Filtrar por empresa',
  'Tickets are not configured for your company yet': 'Chamados ainda não configurados para sua empresa',
  'Could not load tickets': 'Não foi possível carregar os chamados',
  'No tickets yet': 'Nenhum chamado ainda',
  'Medium priority': 'Média',
  'Load more': 'Carregar mais',
  'File type not allowed': 'Tipo de arquivo não permitido',
  'File too large (max 10 MB)': 'Arquivo muito grande (máx. 10 MB)',
  'Ticket created': 'Chamado criado',
  'Ticket review step': 'Revisão',
  'Choose a request type': 'Escolha um tipo de solicitação',
  'Which company is this ticket about?': 'Este chamado é sobre qual empresa?',
  'My own company (default)': 'Minha própria empresa (padrão)',
  'Could not load request types': 'Não foi possível carregar os tipos de solicitação',
  'Could not load form fields': 'Não foi possível carregar os campos do formulário',
  'Upload failed': 'Falha no envio do arquivo',
  'Could not create the ticket': 'Não foi possível criar o chamado',
  'Remove': 'Remover',
  'Uploading': 'Enviando',
  'Messages': 'Mensagens',
  'Write a reply': 'Escreva uma resposta',
  'Could not load the ticket': 'Não foi possível carregar o chamado',
  'Could not send the message': 'Não foi possível enviar a mensagem',
  'Ticket management — Move internal': 'Gestão de chamados — Move interno',
  'SLA at risk': 'SLA em risco',
  'Resolved today': 'Resolvidos hoje',
  'Most frequent types': 'Tipos mais frequentes',
  'Tickets by company': 'Chamados por empresa',
  'Monthly volume': 'Volume mensal',
  'Priority': 'Prioridade',
  'Assignee': 'Responsável',
  'Refresh types': 'Atualizar tipos',
  'Ticket': 'Chamado',
  'Internal note': 'Nota interna',
  'Agent account id': 'ID da conta do agente',
  'Assign': 'Atribuir',
  'Invalid agent account id': 'ID de conta do agente inválido',
  'Could not change the status': 'Não foi possível alterar o status',
  'Could not assign the ticket': 'Não foi possível atribuir o chamado',
  'Only visible to Move': 'Visível apenas para a Move',
  'Totals are global and not affected by the filters': 'Os totais são globais e não são afetados pelos filtros',
  'No data': 'Sem dados',
  'Could not refresh the types': 'Não foi possível atualizar os tipos',
  'Critical priority': 'Crítica',
  'High priority': 'Alta',
  'Low priority': 'Baixa',
  'Based on the loaded list': 'Baseado na lista carregada',
  'Opened on behalf of': 'Aberto em nome de',
  'Could not load the status changes': 'Não foi possível carregar as mudanças de status',
  'Reply to customer': 'Responder ao cliente',
  'Internal note (only visible to Move)': 'Nota interna (visível apenas para a Move)',
  'The ticket may have been created but could not be linked to your company. Do not try again; contact support.': 'O chamado pode ter sido criado, mas não foi possível vinculá-lo à sua empresa. Não tente novamente; entre em contato com o suporte.',
  // MV2-1952
  'Enter a valid e-mail, for example name@email.com':
    'Informe um e-mail válido, por exemplo nome@email.com',
};

export default locale;
